import React, { Component } from 'react';
import { connect } from 'react-redux';
import _, { isEmpty, get, template } from 'lodash';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import $, { error } from 'jquery';
import asyncRoute from '../../../../helpers/hoc/asyncRoute';
import routes from '../../../../routes';
import File from '../../../../components/FormElements/File';
import Input from '../../../../components/FormElements/Input';
import Textarea from '../../../../components/FormElements/Textarea';
import Select from '../../../../components/FormElements/Select';
import SelectNew from '../../../../components/FormElements/SelectNew';
import BinarySelect from '../../../../components/BinarySelect';
import MultiSelect from "../../../../components/FormElements/MultiSelect"
import ModalConfirmation from '../../../../components/ModalConfirmation';
import Checkbox from "../../../../components/FormElements/Checkbox";
import { sortArray, removeSpaces, getCombinedData, getUserListData, isApiCallSuccess } from '../../../../selectors';
import { formFields, formFieldsTenant, confirmationMessage, successfullyMessage, statusOptions, thirdPartySeatsOptions, thirdPartyPlatformOptions, userFormFields, options, countryCodeConstant, countryLengthConstant } from './constant';
import { apiBaseUrl } from "../../../../constants/configuration"
import { handleFieldError, initializeForm, handleError } from '../../../../utils/form-validation';
import {
  getPlatformListAction, getAdminRolesListAction, getCountryAction, getStateAction, getCityAction, getTenantAction, addTenantAction, editTenantAction, getPinCodeAction, getAdminUserListAction, postPaymentCreditAction,
  getAllCurrencyAction, getAllCountryAction, getFilterCurrencyAction, postWalletGetAction, getSubscriptionListManageServiceTrailAction, postRecchageSubscribeAction,
  getUserListByEmailAction, getAdminUserSingleListAction, postMapDefaultSeatsAction, postUserMappedSeatsAction, configAttributeAction,
  postTenantPaymentTypeAction, postTenantSupportedPaymentTypesAction, postTenantSupportedPlatformsAction
} from '../../../../actions';
import { getDataConfigDeatilsAction, getDataConfigDeatilsv1Action } from "../../../../actions/dataConfig";
import { getInfomoViewListAction } from "../../../../actions/connectionManager";
import ToastModal from "../../../../components/ToastModal";
import '../../Admin.scss';
import Modal from '../../../../components/Modal';
import Table from '../../../../components/CustomTable';
import { roleAccessPermissions } from '../../../../api';
import { message } from "antd";

// import SwitchButton from '../../../../components/FormElements/SwitchButton';

const Card = asyncRoute(() => import('../../../../components/Card'));
const BreadCrumb = asyncRoute(() => import('../../../../components/BreadCrumb'));

const Tabs = {
  Tenant: 'tenant',
  contact: 'contact',
  user: 'user'
  // whiteLabel: 'whiteLabel'
};

class AddTenant extends Component {
  constructor(props) {
    super(props);
    this.state = {
      form: {
        isActive: 1
      },
      platform: "",
      contact: {},
      acceptThumbnail: '.jpeg,.jpg,.png,.gif',
      activeTab: Tabs.Tenant,
      touched: {},
      errors: {},
      editMode: false,
      submited: false,
      confirmationOpen: false,
      confirmationInfo: '',
      isPrimaryTenant: false,
      tenantTypeList: [],
      enableToast: false,
      toastStatus: "",
      toastMsg: "",
      confirmationMsg: "",
      userOptions: [
        { email: '', name: '', contact: '', roleTenantList: '', userStatus: 1, errors: {}, touched: {}, },
      ],
      editUserOptions: [],
      viewData: [],
      currentRow: {
        errors: {},
        touched: {}
      },
      editUSerModal: false,
      updatedData: [],
      allCountryOptions: [],
      countriesZoneOptions: [],
      timeZoneOptions: [],
      CurrencyListOptions: [],
      allTypeOgCurrency: [],
      editSetTenantID: '',
      reamainBalance: '',
      formFields: formFields,
      payloadTenantTypeId: '',
      connectionManagement: false,
      feeManagement: false,
      allPlatforms: [],
      thirdPartyPlatforms: [],
      paymentTypes: [],
      infomoSeatsAvailable: null
    };
  }

  async componentWillMount() {
    try {
      const { match: { params: { id } }, match, rolesList } = this.props;
      const { form, contact } = this.state;

      let isAuthenticated = JSON.parse(localStorage.getItem('AuthData'));
      if (isEmpty(isAuthenticated)) {
        const { history } = this.this.props;
        history.push(routes.preSignIn);
      }
      const { tenantId, authToken, userId, getPlatformListAction, getAdminRolesListAction, getTenantAction, configurationList, location: { state } } = this.props;
      const tenantTypeList = get(configurationList.find(tenant => tenant.attrName === 'TENANT_TYPE'), 'attributeValues', []);
      const findData = state != undefined && state.tenantType != undefined && tenantTypeList.find((ele) => ele.value.toLowerCase() == state.tenantType.toLowerCase());
      if (findData) {
        this.setState({ payloadTenantTypeId: findData.key });
      }
      getTenantAction({ tenantId, authToken, userId });
      getAdminRolesListAction({ tenantId, authToken, userId, addParams: 'all' });
      let { responseCode: { status = '' }, responseList } = await getPlatformListAction({ tenantId, authToken, userId });
      if (status = "Success") {
        const platformId = get(responseList.find(platform => platform.name === window.location.hostname), 'id', "");
        this.setState({ platform: platformId })
      }
      await this.formInitialize();
      await this.allCurrencyFunction();
      await this.allCountryFunction();
      await this.getAllCountryTimeZone();
      await this.getAllPlatform();
      await this.getPaymentTypes();

      if (id) {
        this.editId(id);
      }
      else {
        contact.state = '';
      }
    } catch (error) {
      console.log(error);
    }
  }

  async setAccountOwnerAndEmail() {
    const { getAdminUserSingleListAction, tenantId, authToken, userId } = this.props;
    const { form } = this.state;
    let { responseCode: { status = '' }, responseList } = await getAdminUserSingleListAction({ tenantId, authToken, userId, id: userId });
    if (status && status.toLowerCase() == "success" && responseList && responseList.length > 0) {
      form[formFieldsTenant.accountOwnerName.key] = responseList[0]['name'];
      form[formFieldsTenant.accountOwnerEmail.key] = responseList[0]['email'];
    }
  };

  async formInitialize(reset = false) {
    const { match: { params: { id } }, getCountryAction, tenantId, authToken, userId, configurationList } = this.props;
    // const { form, errors } = initializeForm(formFieldsTenant);
    // form.tenantType = tenantId;
    // form.isPrimaryTenant = false;
    if (!id) {
      await this.setAccountOwnerAndEmail();
    }
    const tenantTypeList = get(configurationList.find(tenant => tenant.attrName === 'TENANT_TYPE'), 'attributeValues', []);
    // this.setState({ form, tenantTypeList, errors });
    this.setState({ tenantTypeList })
    if (!reset) {
      await getCountryAction({ tenantId, authToken, userId });
    }
  }

  async contactformInitialize(reset = false) {
    const { getCountryAction, tenantId, authToken, userId } = this.props;
    // const { form, errors } = initializeForm(formFields);
    // this.setState({ contact: form, errors });
    if (!reset) {
      await getCountryAction({ tenantId, authToken, userId });
    }
  }

  allCurrencyFunction = async () => {
    const { tenantId, userId, authToken, getAllCurrencyAction } = this.props
    let { responseCode: { status = '' }, responseList } = await getAllCurrencyAction({ tenantId, authToken, userId });
    if (status.toLowerCase() == "success") {
      this.setState({ allTypeOgCurrency: responseList })
    }

  }

  allCountryFunction = async () => {
    const { tenantId, userId, authToken, getAllCountryAction } = this.props
    let { responseCode: { status = '' }, responseList } = await getAllCountryAction({ tenantId, authToken, userId });
    if (status.toLowerCase() == "success") {
      const optionsCountryList = responseList.map((ele, i) => {
        return {
          id: ele.key, value: ele.value
        }
      })
      this.setState({ allCountryOptions: optionsCountryList })
    }
  }

  getAllCountryTimeZone = async () => {
    const { tenantId, userId, authToken, configAttributeAction } = this.props
    const type = "COUNTRY_TIMEZONE";
    let { responseCode: { status = '' }, responseList } = await configAttributeAction({ tenantId, authToken, userId, type });
    if (status.toLowerCase() == "success") {
      this.setState({ countriesZoneOptions: responseList })
    }
  }


  getAllPlatform = async () => {
    try {
      const { tenantId, userId, authToken, getDataConfigDeatilsAction, getDataConfigDeatilsv1Action } = this.props;
      const params = { list: "all", type: "platform" };
      let { responseCode: { status = '' }, response } = await getDataConfigDeatilsv1Action({ tenantId, authToken, userId, params });
      if (isApiCallSuccess(status) && response && response.length > 0) {
        let platforms = response.filter(platform => platform.value.toLowerCase() !== 'beki');
        this.setState({ allPlatforms: platforms });
      }
    } catch (e) {
      console.log(e);
    }
  };

  getInfomoSeatsForTenant = async (country, currency) => {
    try {
      const { allPlatforms } = this.state;
      const { tenantId, userId, authToken, getInfomoViewListAction, countryList } = this.props;
      let thirdPartyPlatformData = [];
      if (allPlatforms && allPlatforms.length > 0) {
        let countryId = countryList.find(item => item.countryName == country);
        countryId = countryId ? countryId.id : '';
        let params = { list: 'tenant' };
        let payload = {
          advertiserPlatformMargin: {
            currency: currency,
            countryId: Number(countryId)
          }
        };
        let { responseCode: { status = '' }, response } = await getInfomoViewListAction({ tenantId, authToken, userId, params, payload });
        if (isApiCallSuccess(status) && response && response.length > 0) {
          thirdPartyPlatformData = allPlatforms.map(item => {
            let infomoSeats = response.filter(seat => seat.platformId == item.key);
            if (infomoSeats.length > 0) {
              infomoSeats = infomoSeats.map(seat => ({
                accountId: seat.accountId,
                id: seat.id,
                displayName: seat.displayName,
                masterAccountName: seat.masterAccountName ? seat.masterAccountName : seat.accountName,
                checked: true,
                fees: seat.fees,
                agencyFees: 0,
                error: {}
              }));
            }
            return {
              ...item,
              infomoSeats,
              platformAllowed: true
            };
          });
          this.setState({ thirdPartyPlatforms: thirdPartyPlatformData, infomoSeatsAvailable: true });
        } else {
          if (thirdPartyPlatformData && thirdPartyPlatformData.length > 0) {
            thirdPartyPlatformData = thirdPartyPlatformData.map(item => {
              return {
                ...item,
                platformAllowed: item.platformAllowed,
                infomoSeats: []
              };
            });
          } else {
            thirdPartyPlatformData = allPlatforms.map(item => {
              return {
                ...item,
                platformAllowed: true,
                infomoSeats: []
              };
            });
          }
          this.setState({ thirdPartyPlatforms: thirdPartyPlatformData, infomoSeatsAvailable: false });
        }
      }
    } catch (e) {
      console.log(e);
    }
  }

  getPaymentTypes = async () => {
    let paymentTypesData = [];
    const { tenantId, userId, authToken, configAttributeAction } = this.props;
    const { form } = this.state;
    let { responseCode: { status = "" }, responseList } = await configAttributeAction({ tenantId, authToken, userId, type: 'PAYMENT_TYPE' });
    if (isApiCallSuccess(status) && responseList && responseList.length > 0) {
      paymentTypesData = responseList.map(item => ({ ...item, value: item.description }));
    }
    form[formFieldsTenant.paymentTypeId.key] = paymentTypesData[0].key;
    this.setState({ paymentTypes: paymentTypesData, form });
  };

  checkIfCreditIsDisabled = () => {
    const { paymentTypes, form } = this.state;
    let check = false;
    if (paymentTypes && paymentTypes.length > 0) {
      let selectedPaymentType = paymentTypes.find(paymentType => paymentType.key == form[formFieldsTenant.paymentTypeId.key]);
      check = selectedPaymentType && selectedPaymentType.value.toLowerCase() == 'pre-paid only' ? true : false;
    }
    return check;
  };

  fetchSelectedInfomoSeats = async () => {
    const { tenantId, userId, authToken, match: { params: { id } }, postUserMappedSeatsAction } = this.props;
    let params = { list: 'mapped' };
    let payload = {
      thirdPartySeatRequest: {
        advertiserId: Number(id),
        filters: {
          seatTypes: [0]
        }
      }
    };
    const { responseCode: { status }, response = [] } = await postUserMappedSeatsAction({ tenantId, authToken, userId, params, payload });
    if (isApiCallSuccess(status) && response && response.length > 0) {
      let assignedSeatAccountIds = response.map(item => item.accountId);
      const findFeesById = (id, type) => {
        let value = response.find(item => item.accountId == id);
        value = (value && value[type]) ? value[type] : 0;
        return value;
      };
      let { thirdPartyPlatforms } = this.state;
      thirdPartyPlatforms = thirdPartyPlatforms.map(platform => {
        if (platform.infomoSeats) {
          platform.infomoSeats = platform.infomoSeats.map(seat => {
            seat.checked = assignedSeatAccountIds.includes(seat.accountId);
            seat.isDisabled = assignedSeatAccountIds.includes(seat.accountId);
            seat.fees = assignedSeatAccountIds.includes(seat.accountId) ? findFeesById(seat.accountId, 'fees') : seat.fees;
            seat.agencyFees = assignedSeatAccountIds.includes(seat.accountId) ? findFeesById(seat.accountId, 'agencyMargin') : seat.agencyFees;
            return seat;
          });
        }
        return platform;
      });
      this.setState({ thirdPartyPlatforms });
    } else {
      let { thirdPartyPlatforms } = this.state;
      thirdPartyPlatforms = thirdPartyPlatforms.map(platform => {
        if (platform.infomoSeats) {
          platform.infomoSeats = platform.infomoSeats.map(seat => {
            seat.checked = false;
            return seat;
          });
        }
        return platform;
      });
      this.setState({ thirdPartyPlatforms });
    }
  };

  fetchTenantPaymentType = async () => {
    const { tenantId, userId, authToken, match: { params: { id } }, postTenantSupportedPaymentTypesAction } = this.props;
    let payload = { tenantId: id };
    const { responseCode: { status }, response } = await postTenantSupportedPaymentTypesAction({ tenantId, authToken, userId, payload });
    if (isApiCallSuccess(status) && response) {
      if (response.hasOwnProperty('paymentMode')) {
        return response['paymentMode']['id'];
      } else {
        return '';
      }
    };
  };

  // WalletBalance = async () => {
  //   const { form } = this.state
  //   const { tenantId, userId, authToken, postWalletGetAction } = this.props
  //   let id = {
  //     tenantId: tenantId
  //   }
  //   let { responseCode: { status = '' }, response } = await postWalletGetAction(tenantId, authToken, userId, id);
  //   if (status.toLowerCase() == "success") {
  //     console.log(response, "XXX")
  //     form.credit = response.balance
  //   }
  // }

  editId = async (id) => {
    const { form, contact, allTypeOgCurrency, allCountryOptions, countriesZoneOptions } = this.state;
    const { countryList, tenantId, authToken, userId, editTenantAction, configurationList, getStateAction, getCityAction, getPinCodeAction, getFilterCurrencyAction, postWalletGetAction } = this.props;

    let userOptions = []
    let { responseCode: { status = '' }, responseList } = await editTenantAction({ tenantId, authToken, userId, editId: id });
    // await this.WalletBalance();

    if (status.toLowerCase() == "success") {
      const id = {
        tenantId: responseList[0].tenantId
      }
      let { responseCode: { status = '' }, response } = await postWalletGetAction({ tenantId, authToken, userId, id });
      let tenantPaymentType = await this.fetchTenantPaymentType(id);

      if (status.toLowerCase() == "success") {
        const reamainBalance = response && response.balance;
        let currencyIDValue = allTypeOgCurrency.find((ele) => ele.key == responseList[0].currencyType);
        form.tenantName = responseList[0].tenantName
        form.tenantTypeId = responseList[0].tenantType && responseList[0].tenantType == "DSP/Ad network" ? 'DSP/Ad network' : responseList[0].tenantType
        form.country = responseList[0].contact.country;
        form.currency = currencyIDValue && currencyIDValue.value
        form[formFieldsTenant.timezone.key] = (responseList[0] && responseList[0].timezone) ? responseList[0].timezone : ""
        // form.thirdPartySeats = PlatformsSeatsAllowedId.value
        // form.thirdPartyPlatforms = PlatformsAllowedId.value
        form.isActive = responseList[0].isActive
        // form.credit = response.balance
        form.credit = 0
        form[formFieldsTenant.paymentTypeId.key] = tenantPaymentType;
        if (responseList[0] && responseList[0].contact.country) {
          const findTimeZoneCountryData = countriesZoneOptions.find((data) => data.value == responseList[0].contact.country);
          if (findTimeZoneCountryData && findTimeZoneCountryData.attributeChildValues) {
            this.setState({ timeZoneOptions: findTimeZoneCountryData.attributeChildValues })
          }
        }
        if (responseList[0].hasOwnProperty('miscData')) {
          let miscData = responseList[0].miscData;
          const hascontactPerson = miscData.some(obj => obj.key === 'contactPerson');
          const hascontactEmail = miscData.some(obj => obj.key === 'contactEmail');
          if (hascontactPerson && hascontactEmail) {
            const contactPerson = miscData.find(obj => obj.key === 'contactPerson');
            const contactEmail = miscData.find(obj => obj.key === 'contactEmail');
            contact.contactPerson = contactPerson['value']
            contact.contactEmail = contactEmail['value']
          } else {
            await this.setAccountOwnerAndEmail();
          }
          const hasConnectionManagement = miscData.some(obj => obj.key === 'connectionManagement');
          const hasFeeManagement = miscData.some(obj => obj.key === 'feeManagement');
          if (hasConnectionManagement && hasFeeManagement) {
            let connectionManagement = miscData.find(obj => obj.key === 'connectionManagement');
            connectionManagement = Number(connectionManagement.value) ? true : false;
            let feeManagement = miscData.find(obj => obj.key === 'feeManagement');
            feeManagement = Number(feeManagement.value) && Number(feeManagement.value) ? true : false;
            this.setState({ connectionManagement, feeManagement });
          }
        }
        form[formFieldsTenant.accountOwnerName.key] = responseList[0].contactPerson;
        form[formFieldsTenant.accountOwnerEmail.key] = responseList[0].contactEmail;
        contact.organizationTitle = responseList[0].contact.organizationTitle
        contact.gst = responseList[0].contact.gst
        contact.address1 = responseList[0].contact.address1
        contact.address2 = responseList[0].contact.address2
        contact.state = responseList[0].contact.state
        contact.city = responseList[0].contact.city
        contact.pinCode = responseList[0].contact.pinCode
        contact.contactPhone = responseList[0].contact.contactPhone
        responseList[0].user && responseList[0].user.length > 0 && responseList[0].user.forEach((userdata, userIndex) => {
          let obj = {}
          obj.email = userdata.email
          obj.name = userdata.name
          obj.contact = userdata.contact
          obj.roleTenantList = userdata.roleTenantList[0].roleName
          obj.userStatus = userdata.isActive
          obj.errors = {};
          obj.touched = {};
          userOptions.push(obj)
        })

        let CurrencyOptions;
        if (form.country) {
          let country = countryList.find((item) => item.countryName === form.country);
          let newCodeForCountry = allCountryOptions.find((cCode) => cCode.value == form.country)
          let countryID = newCodeForCountry.id
          let { responseCode: { status = '' }, responseList } = await getFilterCurrencyAction({ tenantId, authToken, userId, countryID });
          if (status.toLowerCase() == "success") {
            Object.keys(responseList[0]).map((dataCurrency) => {
              CurrencyOptions = responseList[0][dataCurrency].map((dataCurr) => {
                return {
                  id: dataCurr.value, value: dataCurr.value
                }
              })
            })
          }
          getStateAction({ tenantId, authToken, userId, countryCode: { cncode: country.countryCode } });
        }


        // let CurrencyOptions
        // if (value) {
        //   let country = countryList.find((item) => item.countryName === value);
        //   let newCodeForCountry = allCountryOptions.find((cCode) => cCode.value == value)
        //   let countryID = newCodeForCountry.id
        //   let { responseCode: { status = '' }, responseList } = await getFilterCurrencyAction({ tenantId, authToken, userId, countryID });
        //   Object.keys(responseList[0]).map((dataCurrency) => {
        //     CurrencyOptions = responseList[0][dataCurrency].map((dataCurr) => {
        //       return {
        //         id: dataCurr.value, value: dataCurr.value
        //       }
        //     })
        //   })
        //   this.setState({ CurrencyListOptions: CurrencyOptions })
        //   getStateAction({ tenantId, authToken, userId, countryCode: { cncode: country.countryCode } });
        let processedUsersData = responseList[0].user.map(user => ({ ...user, isRoleActive: user.roleTenantList[0].isRecActive }));
        this.setState({ form, contact, userOptions, viewData: processedUsersData, CurrencyListOptions: CurrencyOptions, editSetTenantID: responseList[0].tenantId, reamainBalance })
        await this.getInfomoSeatsForTenant(form.country, form.currency);
        await this.setTenantAllowedPlatforms(id.tenantId);
        await this.fetchSelectedInfomoSeats();
      }
    }
  }

  getAccountOwnerDetails = async (ownerEmail) => {
    let userData;
    const params = {
      list: "search",
      srch: ownerEmail.toLowerCase()
    };
    const { tenantId, userId, authToken, getUserListByEmailAction } = this.props;
    const { responseCode: { status = "" }, responseList = [] } = await getUserListByEmailAction({ tenantId, authToken, userId, params });
    if (isApiCallSuccess(status) && responseList && responseList.length > 0) {
      userData = responseList;
    };
    return userData;
  };

  handleNavigation = (event) => {
    // todo: strategy -- reset form or make selected first one

    if (event.target.name === 'pmp') {
      this.setState({ activeTab: event.target.name });
      return;
    }
    const { activeTab } = this.state;
    if (activeTab === Tabs.configuration) {
      this.handleNext(event.target.name);
    } else {
      this.setState({ activeTab: event.target.name });
      this.navigateToTop();
    }

    // uncomment code afer testing
    // this.setState({ activeTab: event.target.name })
  };

  navigateToTop() {
    $('html, body').animate({ scrollTop: 0 }, 500);
  }

  resetErrorAndTouchedInKey(key) {
    const { errors, touched } = this.state;
    delete errors[key];
    delete touched[key];
    this.setState({ errors, touched });
  }

  handleChange = async (e) => {
    try {
      const { getStateAction, getCityAction, configurationList, countryList, getStateList, getCityList, getPinCodeAction, tenantId, authToken, userId, getFilterCurrencyAction } = this.props;
      let { form, contact, activeTab, allCountryOptions, countriesZoneOptions } = this.state;
      let { value, name, min, max, checked = false } = e.target;

      if (min && max) {
        value = Math.max(Number(min), Math.min(Number(max), Number(value)));
      }

      if (name == 'tenantTypeId') {
        const tenantTypeList = get(configurationList.find(tenant => tenant.attrName === 'TENANT_TYPE'), 'attributeValues', []);
        if (value == "DSP/Ad network") {
          const findData = tenantTypeList.find((ele) => ele.value == "DSP/Ad network")
          this.setState({ payloadTenantTypeId: findData.key })
        } else {
          const findData = tenantTypeList.find((ele) => ele.value == value)
          this.setState({ payloadTenantTypeId: findData.key })
        }
      }

      if (name == 'country') {
        let CurrencyOptions
        if (value) {
          let country = countryList.find((item) => item.countryName == value);
          let newCodeForCountry = allCountryOptions.find((cCode) => cCode.value == value)
          let countryID = newCodeForCountry.id
          let { responseCode: { status = '' }, responseList } = await getFilterCurrencyAction({ tenantId, authToken, userId, countryID });
          Object.keys(responseList[0]).map((dataCurrency) => {
            CurrencyOptions = responseList[0][dataCurrency].map((dataCurr) => {
              return {
                id: dataCurr.value, value: dataCurr.value
              }
            })
          })


          if (country && country.countryName) {
            const findTimeZoneCountryData = countriesZoneOptions.find((data) => data.value == country.countryName);
            if (findTimeZoneCountryData && findTimeZoneCountryData.attributeChildValues) {
              this.setState({ timeZoneOptions: findTimeZoneCountryData.attributeChildValues })
            }
          }


          form[formFieldsTenant.timezone.key] = "";
          this.setState({ CurrencyListOptions: CurrencyOptions })
          getStateAction({ tenantId, authToken, userId, countryCode: { cncode: country ? country.countryCode : '' } });

          const localStorageTenantData = JSON.parse(localStorage.getItem("PreSignInData"))
          const logedInTenantDeatail = localStorageTenantData && localStorageTenantData.responseList && localStorageTenantData.responseList.find((data) => data.tenantId == tenantId)

          const PhoneNumberMergedArray = countryCodeConstant.map((data) => {
            const matchingItem2 = countryLengthConstant.find((data2) => data2.country === data.name);
            if (matchingItem2) {
              // If a match is found, merge the data
              return { ...data, ...matchingItem2 };

            } else {
              // If no match is found, return the original item from array1
              return data;
            }
          })


          const findLengthPhoneNumber = PhoneNumberMergedArray && PhoneNumberMergedArray.find((ele) => ele.name == value)

          this.setState({ phonenumberLenghtValidationPacket: findLengthPhoneNumber })
          this.setState((prevState) => ({
            formFields: {
              ...prevState.formFields,
              contactPhone: {
                ...prevState.formFields.contactPhone,
                pattern: findLengthPhoneNumber ? new RegExp(`^\\d{${findLengthPhoneNumber.phoneNumberLengthByCountry_phLength}}$`) : '',
                patternMessage: findLengthPhoneNumber ? `Minimum and Maximum  ${findLengthPhoneNumber.phoneNumberLengthByCountry_phLength} digit allowed.` : '',
              },
            },
          }));

        }
        if (contact) {
          contact.contactPhone = ''
        }

        if (CurrencyOptions && CurrencyOptions.length == 1) {
          await this.getInfomoSeatsForTenant(value, CurrencyOptions[0].id);
        }

        form.currency = CurrencyOptions.length == 1 ? CurrencyOptions[0].id : '';
        contact.state = '';
        contact.city = '';
        this.resetErrorAndTouchedInKey(formFieldsTenant.currency.key);
      }
      else if (name === 'state') {
        if (value) {
          let country = countryList.find((item) => item.countryName === form.country);
          let state = getStateList.find((item) => item.stateName === value);
          getCityAction({ tenantId, authToken, userId, cncode: country.countryCode, scode: state.stateCode });
        }
        contact.city = '';
      } else if (name === 'city') {
        if (value) {
          let country = countryList.find((item) => item.countryName === form.country);
          let state = getStateList.find((item) => item.stateName === contact.state);
          let city = getCityList.find((item) => item.cityName === value);
          getPinCodeAction({ tenantId, authToken, userId, cncode: country.countryCode, scode: state.stateCode, ccode: city.id });
        }
        contact.pinCode = '';
      }

      if (name == formFieldsTenant.currency.key) {
        this.getInfomoSeatsForTenant(form[formFieldsTenant.country.key], value);
      }

      if (name === "isPrimaryTenant") {
        form[name] = checked;
      }
      if (activeTab === Tabs.Tenant) {
        form[name] = value;
        this.setState({ form });
      }
      else if (activeTab === Tabs.contact) {
        contact[name] = value
        this.setState({ contact });
      }
    } catch (err) {
      console.log(err);
    }
  };

  handleTouch = (e) => {
    let { touched, form, errors } = this.state;
    const { name, value } = e.target;
    let { error } = handleFieldError(value, formFieldsTenant[name]);
    errors[e.target.name] = error;
    touched[e.target.name] = true;
    this.setState({ touched, errors });
  };

  handleContactTouch = (e) => {
    let { touched, contact, errors, formFields } = this.state;
    let { error } = handleFieldError(contact[e.target.name], formFields[e.target.name]);
    errors[e.target.name] = error;
    touched[e.target.name] = true;
    this.setState({ touched, errors });
  };

  toggleModal = (confirmation) => {
    const { confirmationOpen } = this.state;
    this.setState({ confirmationOpen: !confirmationOpen, confirmationInfo: confirmation });
  };

  confirmationCallBack = (success, info) => {
    const { confirmationOpen, feeManagement } = this.state;
    if (success && info.action.type === 'Confirmation') {
      this.submitForm();
    } else if (success && info.action.type === 'feeSetting') {
      this.setState({ feeManagement: !feeManagement });
    } else if (info.action.type === 'alert') {
      this.setState({ confirmationOpen: !confirmationOpen }, () => {
        const { history } = this.props;
        history.push(`/${routes.mainRoute}/${routes.containers.admin}/${routes.admin.tenant.name}`);
      });
      return;
    }
    this.setState({ confirmationOpen: false });
  };

  GenratePayload = async () => {
    const { form, contact, payloadTenantTypeId, userOptions, updatedData, allTypeOgCurrency, editSetTenantID, viewData, editUserOptions, connectionManagement, feeManagement, infomoSeatsAvailable } = this.state
    const { match: { params: { id } }, addTenantAction, tenantId, authToken, userId, configurationList, rolesList, postPaymentCreditAction } = this.props
    if (id) {
      let addParams = { action: 'update' };
      let currencyID = allTypeOgCurrency.find((item) => item.value === form.currency);
      const pspList = get(configurationList.find(list => list.attrName === 'PSP_LIST'), 'attributeValues', []);
      const pspListID = pspList && pspList[1].key
      let findData = {}

      const tenantTypeList = get(configurationList.find(tenant => tenant.attrName === 'TENANT_TYPE'), 'attributeValues', []);

      if (form.tenantTypeId == "DSP/Ad network") {
        findData = tenantTypeList && tenantTypeList.find((ele) => ele.value == "DSP/Ad network")
      } else {
        findData = tenantTypeList && tenantTypeList.find((ele) => ele.value == form.tenantTypeId);
      }
      let ContactFormData = contact ? contact : contact

      let Ammount = form.credit

      let users = [];
      let viewDataUsers = viewData.map(user => {
        return {
          id: user.id ? user.id : null,
          name: user.name,
          uID: user.email,
          email: user.email,
          contact: user.contact,
          isRecActive: user.isRecActive,
          isActive: user.isActive,
          roleTenantList: user.roleTenantList
        }
      });
      users = viewDataUsers;
      let areAllFieldsEmpty = true;
      if (editUserOptions && editUserOptions.length > 0) {
        areAllFieldsEmpty = editUserOptions[0].name === "" && editUserOptions[0].email === "" && editUserOptions[0].contact === "" && editUserOptions[0].roleTenantList === "";
      }
      if (!areAllFieldsEmpty) {
        let addedUsers = editUserOptions.map(user => {
          const roleID = rolesList.find((e) => Number(e.roleId) == Number(user.roleTenantList));
          return {
            id: user.id ? user.id : null,
            name: user.name,
            uID: user.email,
            email: user.email,
            contact: user.contact,
            isRecActive: +user.userStatus,
            isActive: 1,
            roleTenantList: [
              {
                roleId: roleID ? Number(roleID.roleId) : null,
                isRecActive: +user.userStatus,
                isActive: 1,
                roleName: roleID.roleName,
              }
            ]
          }
        });
        users = [...users, ...addedUsers];
      }

      // const accountOwnerData = await this.getAccountOwnerDetails(form[formFieldsTenant.accountOwnerEmail.key]);
      // const defaultRole = rolesList.find(role => role.isActive && role.roleType === 3);

      // if (accountOwnerData && accountOwnerData.length > 0) {
      //   const isAccountOwnerPresent = users.some(item => item.email == form[formFieldsTenant.accountOwnerEmail.key]);
      //   if (!isAccountOwnerPresent && defaultRole) {
      //     const accountOwnerUser = accountOwnerData.map(item => ({
      //       ...item,
      //       roleTenantList: [{ roleId: Number(defaultRole.roleId), isActive: 1, isRecActive: 1 }],
      //       isActive: item.isRecActive
      //     }));
      //     users = [...users, ...accountOwnerUser];
      //   }
      // } else {
      //   const isAccountOwnerPresent = users.some(item => item.email == form[formFieldsTenant.accountOwnerEmail.key]);
      //   if (!isAccountOwnerPresent && defaultRole) {
      //     const accountOwnerUser = [{
      //       name: form[formFieldsTenant.accountOwnerName.key],
      //       email: form[formFieldsTenant.accountOwnerEmail.key],
      //       uID: form[formFieldsTenant.accountOwnerEmail.key],
      //       isActive: 1,
      //       isRecActive: 1,
      //       roleTenantList: [{ roleId: Number(defaultRole.roleId), isRecActive: 1, isActive: 1 }]
      //     }];
      //     users = [...users, ...accountOwnerUser];
      //   }
      // }

      const payload = {
        tenantId: id ? id : '',
        tenantName: form.tenantName,
        tenantType: findData.key,
        tenantTypeId: +findData.key,
        contactEmail: form[formFieldsTenant.accountOwnerEmail.key],
        tenantMode: 0,
        contactPerson: form[formFieldsTenant.accountOwnerName.key],
        contact: {
          address1: ContactFormData.address1,
          address2: ContactFormData.address2,
          contactPhone: ContactFormData.contactPhone,
          country: form.country,
          state: ContactFormData.state,
          city: ContactFormData.city,
          gst: ContactFormData.gst,
          pincode: ContactFormData.pincode,
          organizationTitle: ContactFormData.organizationTitle,
        },
        miscData: [
          { key: 'contactPerson', value: ContactFormData.contactPerson },
          { key: 'contactEmail', value: ContactFormData.contactEmail },
          { key: 'connectionManagement', value: Number(connectionManagement) ? 1 : 0 },
          { key: 'feeManagement', value: Number(feeManagement) ? 1 : 0 }
        ],
        currencyType: currencyID.key,
        timezone: +form.timezone,
        isActive: form.isActive,
        user: users
      }


      // if (id) {
      //   addParams = { action: 'update' };
      // }

      const res = await addTenantAction({ tenantId, authToken, userId, payload, addParams });

      if (res.responseCode.status) {
        if (isApiCallSuccess(res.responseCode.status)) {
          let newTeanantId = {
            tenantId: editSetTenantID && editSetTenantID
          }
          if (Ammount && Number(Ammount) > 0) {
            let { responseList } = await postPaymentCreditAction({ tenantId, authToken, userId, newTeanantId, Ammount, pspListID });

          }
          await this.mapTenantPaymentType(id, Ammount);
          await this.allotPlatforms(id);
          if (infomoSeatsAvailable) {
            await this.allotInfomoSeats(id);
          }
          this.toast(res.responseCode.status, res.responseCode.msg);
        }
      }
    }
    else {
      let addParams = { action: 'create' };
      let currencyID = allTypeOgCurrency.find((item) => item.value === form.currency);
      const pspList = get(configurationList.find(list => list.attrName === 'PSP_LIST'), 'attributeValues', []);
      const pspListID = pspList && pspList[1].key
      const tenantTypeList = get(configurationList.find(tenant => tenant.attrName === 'TENANT_TYPE'), 'attributeValues', []);
      let tenantType = tenantTypeList.find((ele) => ele.value.toLowerCase() == form[formFieldsTenant.tenantTypeId.key].toLowerCase());
      let ContactFormData = contact ? contact : contact

      let Ammount = form.credit;

      let users = [];
      let areAllFieldsEmpty = true;
      if (userOptions && userOptions.length > 0) {
        areAllFieldsEmpty = userOptions[0].name == "" && userOptions[0].email == "" && userOptions[0].contact == "" && userOptions[0].roleTenantList == "";
      }
      if (!areAllFieldsEmpty) {
        let addedUsers = userOptions.map(user => {
          const roleID = rolesList.find((e) => e.roleId == user.roleTenantList);
          return {
            id: user.id ? user.id : null,
            name: user.name,
            uID: user.email,
            email: user.email,
            contact: user.contact,
            isRecActive: +user.userStatus,
            isActive: 1,
            roleTenantList: [
              {
                roleId: roleID ? roleID.roleId : null,
                isRecActive: +user.userStatus,
                isActive: 1,
                roleName: user.roleTenantList,
              }
            ]
          }
        });
        users = addedUsers;
      }

      // const accountOwnerData = await this.getAccountOwnerDetails(form[formFieldsTenant.accountOwnerEmail.key]);
      // const defaultRole = rolesList.find(role => role.isActive && role.roleType === 3);
      // if (accountOwnerData && accountOwnerData.length > 0) {
      //   const isAccountOwnerPresent = users.some(item => item.email == form[formFieldsTenant.accountOwnerEmail.key]);
      //   if (!isAccountOwnerPresent && defaultRole) {
      //     const accountOwnerUser = accountOwnerData.map(item => ({
      //       ...item,
      //       roleTenantList: [{ roleId: Number(defaultRole.roleId), isActive: 1 }],
      //       isActive: item.isRecActive
      //     }));
      //     users = [...users, ...accountOwnerUser];
      //   }
      // } else {
      //   const isAccountOwnerPresent = users.some(item => item.email == form[formFieldsTenant.accountOwnerEmail.key]);
      //   if (!isAccountOwnerPresent && defaultRole) {
      //     const accountOwnerUser = [{
      //       name: form[formFieldsTenant.accountOwnerName.key],
      //       email: form[formFieldsTenant.accountOwnerEmail.key],
      //       uID: form[formFieldsTenant.accountOwnerEmail.key],
      //       isActive: 1,
      //       isRecActive: 1,
      //       roleTenantList: [{ roleId: Number(defaultRole.roleId), isActive: 1, isRecActive: 1 }]
      //     }];
      //     users = [...users, ...accountOwnerUser];
      //   }
      // }

      const payload = {
        tenantName: form.tenantName.replace(/\s\s+/g, ' '),
        tenantType: payloadTenantTypeId,
        tenantTypeId: +payloadTenantTypeId,
        contactEmail: form[formFieldsTenant.accountOwnerEmail.key],
        contactPerson: form[formFieldsTenant.accountOwnerName.key],
        tenantMode: 0,
        contact: {
          address1: ContactFormData.address1,
          address2: ContactFormData.address2,
          contactPhone: ContactFormData.contactPhone,
          country: form.country,
          state: ContactFormData.state,
          city: ContactFormData.city,
          gst: ContactFormData.gst,
          pinCode: ContactFormData.pinCode,
          organizationTitle: ContactFormData.organizationTitle,
        },
        miscData: [
          { key: 'contactPerson', value: ContactFormData.contactPerson },
          { key: 'contactEmail', value: ContactFormData.contactEmail },
          { key: 'connectionManagement', value: connectionManagement ? 1 : 0 },
          { key: 'feeManagement', value: feeManagement ? 1 : 0 }
        ],
        currencyType: currencyID.key,
        timezone: +form.timezone,
        isActive: form.isActive,
        user: users
      }

      const res = await addTenantAction({ tenantId, authToken, userId, payload, addParams });

      if (res && res.responseCode.status) {
        if (isApiCallSuccess(res.responseCode.status)) {
          let newTeanantId = {
            tenantId: res.response
          }
          if (Ammount && Number(Ammount) > 0) {
            let { responseList } = await postPaymentCreditAction({ tenantId, authToken, userId, newTeanantId, Ammount, pspListID });
          }
          await this.mapTenantPaymentType(res.response, Ammount);
          if (infomoSeatsAvailable) {
            await this.allotInfomoSeats(res.response);
          }
          if (connectionManagement) {
            await this.mapDefaultSeats(res);
            await this.allotPlatforms(res.response);
          }
          const costDetailsConfigData = get(configurationList.find(list => list.attrName === 'COSTING_DETAILS'), 'attributeValues', []);
          await this.FreeTrailFunction(costDetailsConfigData, res);
        } else {
          this.toast(res.responseCode.status, res.responseCode.msg);
        }
      }
    }
  }

  FreeTrailFunction = async (costDetailsConfigData, createTeanantId) => {
    // console.log(createTeanantId, "createTeanantId")
    const { getSubscriptionListManageServiceTrailAction, postRecchageSubscribeAction, history, authToken, tenantId, userId } = this.props
    const payload = {
      tenantId: createTeanantId && createTeanantId.response
    }
    const { responseCode: { status }, response } = await getSubscriptionListManageServiceTrailAction({ tenantId, authToken, userId, payload });
    let costConfigValue
    let CostingValueforPayload
    if (status.toLowerCase() == "success") {
      response && response[0].configData && response[0].configData.length > 0 && response[0].configData.forEach((dataRes) => {
        costConfigValue = costDetailsConfigData.find((cost) => cost.key == dataRes.catId);
        if (costConfigValue) {
          CostingValueforPayload = costConfigValue
        }
      })
      let planId = response && response.length > 0 ? response[0].id : null;
      // const AmountCost = response && response[0].configData && response[0].configData.length && response[0].configData.find((dataID) => dataID.catId == CostingValueforPayload.key)
      const payload = {
        isAutoRechage: 0,
        planId: planId,
        tenantId: createTeanantId && createTeanantId.response
      }
      // console.log(payload, "PAYLOAD")
      const { responseCode: { status, msg } } = await postRecchageSubscribeAction({ tenantId, authToken, userId, payload });
      if (isApiCallSuccess(status)) {
        this.toast(createTeanantId.responseCode.status, createTeanantId.responseCode.msg);
      } else {

      }
    } else {
      let message = "Tenant created Successfully, but due to some technical issues, the subscription / free trial could not be activated."
      const info = { action: { confirmationMessage: message, type: 'error' } };
      this.toggleModal(info);
    }
  }

  allotInfomoSeats = async (createdTenantId) => {
    const { postMapDefaultSeatsAction, authToken, tenantId, userId } = this.props;
    const { thirdPartyPlatforms, form, feeManagement } = this.state;
    let allInfomoSeats = [];
    thirdPartyPlatforms.forEach(platform => {
      allInfomoSeats = [...allInfomoSeats, ...platform.infomoSeats];
    });
    let selectedInfomoSeats = allInfomoSeats.filter(seat => seat.checked == true);
    if (selectedInfomoSeats && selectedInfomoSeats.length > 0) {
      let params = { map: 'infomo' };
      let marginInfoMap = {};
      let isAgencyAndFeeManagementSelected = (feeManagement && form[formFieldsTenant.tenantTypeId.key] == 'DSP/Ad network');
      selectedInfomoSeats.forEach(seat => {
        marginInfoMap[seat.id] = {
          infomoMargin: seat.fees,
          agencyMargin: isAgencyAndFeeManagementSelected ? seat.agencyFees : 0
        };
      });
      const payload = {
        advertiserPlatformMargin: {
          marginInfoMap,
          advertiserId: Number(createdTenantId)
        }
      };
      const { responseCode: { status = '' } } = await postMapDefaultSeatsAction({ tenantId, authToken, userId, params, payload });
      if (isApiCallSuccess(status)) {
        console.log('Infomo seats mapped successfully!');
      }
    }
  }

  allotPlatforms = async (createdTenantId) => {
    const { postTenantSupportedPlatformsAction, authToken, tenantId, userId } = this.props;
    const { thirdPartyPlatforms, form } = this.state;
    let selectedPlatforms = thirdPartyPlatforms.filter(platform => platform.platformAllowed);
    selectedPlatforms = selectedPlatforms && selectedPlatforms.length > 0 ? selectedPlatforms.map(platform => ({ platformId: platform.key, platformName: platform.value })) : [];
    let params = { type: 'addUpdate' };
    const payload = {
      tenantId: createdTenantId,
      platformsRequest: {
        platforms: selectedPlatforms
      }
    };
    const { responseCode: { status = '' } } = await postTenantSupportedPlatformsAction({ tenantId, authToken, userId, params, payload });
    if (isApiCallSuccess(status)) {
      console.log('Platforms alloted successfully!');
    }
  }

  mapDefaultSeats = async (createdTenantId) => {
    const { postMapDefaultSeatsAction, authToken, tenantId, userId } = this.props;
    let params = { map: 'default' };
    let payload = {
      thirdPartySeatRequest: {
        advertiserId: createdTenantId.response
      }
    };
    const { responseCode: { status = '' } } = await postMapDefaultSeatsAction({ tenantId, authToken, userId, params, payload });
    if (isApiCallSuccess(status)) {
      console.log('Default seats mapped successfully!');
    }
  }

  mapTenantPaymentType = async (createdTenantId, creditAmount) => {
    const { postTenantPaymentTypeAction, authToken, tenantId, userId } = this.props;
    const { form } = this.state;
    let payload = {
      tenantId: Number(createdTenantId),
      paymentType: {
        creditAmount: creditAmount > 0 ? Number(creditAmount) : null,
        paymentMode: {
          id: Number(form[formFieldsTenant.paymentTypeId.key])
        },
        paymentCreditType: 1
      }
    };
    const { responseCode: { status = '' } } = await postTenantPaymentTypeAction({ tenantId, authToken, userId, payload });
    if (isApiCallSuccess(status)) {
      console.log('Payment Type Mapped Successfully!');
    }
  }

  setTenantAllowedPlatforms = async (id) => {
    const { postTenantSupportedPlatformsAction, authToken, tenantId, userId } = this.props;
    let { thirdPartyPlatforms } = this.state;
    let params = { type: 'list' };
    const payload = {
      tenantId: id
    };
    const { responseCode: { status = '' }, response } = await postTenantSupportedPlatformsAction({ tenantId, authToken, userId, params, payload });
    if (isApiCallSuccess(status)) {
      const allowedPlatformIds = response.map(item => item.platformId);
      thirdPartyPlatforms = thirdPartyPlatforms.map(item => {
        return {
          ...item,
          platformAllowed: allowedPlatformIds.includes(item.key)
        }
      })
      this.setState({ thirdPartyPlatforms });
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const { form, contact, formFields, feeManagement, thirdPartyPlatforms } = this.state;
    let isError = false;
    if (!this.infomoSeatMarginValid()) {
      message.error('Infomo margins are not valid!');
      isError = true;
    }

    if ((feeManagement && (form[formFieldsTenant.tenantTypeId.key] == 'DSP/Ad network' || form[formFieldsTenant.tenantTypeId.key] == 'Demo Agency'))) {
      if (!this.agencyMarginValid()) {
        message.error('Agency margins are not valid!');
        isError = true;
      }
    }

    if (isError) {
      return;
    }

    let { errors, valid } = handleError(form, formFieldsTenant);

    if (valid) {
      // Todo confirmation user
      let { errors, valid } = handleError(contact, formFields);
      let validAssignUsers = this.validateAssignUsers();
      if (valid && !validAssignUsers) {
        this.setState({ enableToast: true, toastStatus: 'confirmation', confirmationMsg: "Kindly let us know if you'd like to save your changes." });
      }
      else {
        // const errorMessage = { action: { confirmationMessage: 'Please enter valid details.', type: 'error' } }
        // this.toggleModal(errorMessage)
        this.setState({ errors: errors, submited: true });
      }
    } else {
      this.setState({ activeTab: Tabs.Tenant, errors: errors, submited: true });
    }
  };

  handleNextpage = (e) => {
    e.preventDefault();
    const { form } = this.state;
    let { errors, valid } = handleError(form, formFieldsTenant);
    if (valid) {
      // Todo confirmation user
      this.handleNavigation(e)
    } else {
      this.setState({ errors: errors, submited: true });
    }
  };

  reset = () => {
    this.formInitialize(true);
  };

  toast = (status, msg) => {
    this.setState({ enableToast: true, toastStatus: status, toastMsg: msg });
    return;
  };

  confirmationCallbackModel = (id) => {
    this.setState({ enableToast: false }, () => {
      this.GenratePayload();
    });
  };

  handleToastStatus = (status) => {
    this.setState({ enableToast: status });
  };

  addUser = () => {
    const { match: { params: { id } }, match } = this.props;
    if (id) {
      let { editUserOptions } = this.state;
      let option = { email: '', name: '', contact: '', roleTenantList: '', userStatus: 1, errors: {}, touched: {}, };
      editUserOptions.push(option);
      this.setState({ editUserOptions });
    } else {
      let { userOptions } = this.state;
      let option = { email: '', name: '', contact: '', roleTenantList: '', userStatus: 1, errors: {}, touched: {}, };
      userOptions.push(option);
      this.setState({ userOptions });
    }
  };

  removeUser = (index) => {
    const { match: { params: { id } }, match } = this.props;
    if (id) {
      let { editUserOptions } = this.state;
      editUserOptions = editUserOptions.filter((user, i) => index !== i);
      this.setState({ editUserOptions });
    } else {
      let { userOptions } = this.state;
      userOptions = userOptions.filter((user, i) => index !== i);
      this.setState({ userOptions });
    }
  };

  validateAssignUsers = () => {
    try {
      const userFormFieldsError = { name: {}, contact: {}, email: {}, roleTenantList: {}, userStatus: {} };
      const userFormFieldsTouched = { name: {}, contact: {}, email: {}, roleTenantList: {}, userStatus: {} };
      const { match: { params: { id } }, match } = this.props;
      const { userOptions, editUserOptions } = this.state;
      let assignUsers = id ? editUserOptions : userOptions;
      let usersHasErrors = false;
      if (assignUsers && assignUsers.length > 0) {
        const areAllFieldsEmpty = assignUsers[0].name === "" && assignUsers[0].email === "" && assignUsers[0].contact === "" && assignUsers[0].roleTenantList === "";
        if (!areAllFieldsEmpty) {
          let updatedAssignUsers = assignUsers.map((user) => {
            let updatedUser = { ...user };
            if (user.email || user.email == null || user.email == '') {
              const { error, isValid } = handleFieldError(user.email, userFormFields[userFormFields.email.key]);
              updatedUser['errors'][userFormFields.email.key] = error;
              updatedUser['touched'][userFormFields.email.key] = true;
              usersHasErrors = !isValid;
            }
            if (user.name == '') {
              updatedUser['errors'][userFormFields.name.key] = { required: true };
              updatedUser['touched'][userFormFields.name.key] = true;
              usersHasErrors = true;
            }
            // if (user.contact) {
            //     const { error } = handleFieldError(user.contact, userFormFields[userFormFields.contact.key]);
            //     updatedUser['errors'][userFormFields.contact.key] = error;
            //     updatedUser['touched'][userFormFields.contact.key] = true;
            //     usersHasErrors = true;
            // }
            if (user.roleTenantList == '') {
              updatedUser['errors'][userFormFields.roleTenantList.key] = { required: true };
              updatedUser['touched'][userFormFields.roleTenantList.key] = true;
              usersHasErrors = true;
            }
            return updatedUser;
          });
          if (usersHasErrors == false) {
            updatedAssignUsers = updatedAssignUsers.map(user => ({ ...user, errors: userFormFieldsError, touched: userFormFieldsTouched }));
          }
          if (id) {
            this.setState({ editUserOptions: updatedAssignUsers });
          } else {
            this.setState({ userOptions: updatedAssignUsers });
          }
        }
      }
      return usersHasErrors;
    } catch (e) {
      console.log(e);
    }
  };

  handleAction = (row, action) => {
    const { match, history } = this.props;
    if (action.type === 'edit') {
      this.handleEdit(row, match, history);
    } else if (action.key == 'isRoleActive') {
      this.handleStatus(row);
    }
  };

  handleEdit(row, match, history) {
    let { editUSerModal, currentRow } = this.state;
    if (!editUSerModal) {
    }
    currentRow = {
      id: row.id,
      email: row.email,
      name: row.name,
      contact: row.contact,
      roleTenantList: Number(row.roleTenantList[0].roleId),
      isRoleActive: row.roleTenantList[0].isRecActive,
      errors: {},
      touched: {}
    };
    this.setState({ editUSerModal: !editUSerModal, errors: {}, currentRow });
  };

  async handleStatus(row) {
    try {
      const { viewData } = this.state;
      let updatedViewData = viewData.map((user) => {
        if (user.id == row.id) {
          if (Number(row.isRoleActive) == 1) {
            user.roleTenantList[0].isRecActive = 0;
            user.isRoleActive = 0;
          } else {
            user.roleTenantList[0].isRecActive = 1;
            user.isRoleActive = 1;
          }
        }
        return user;
      });
      this.setState({ viewData: updatedViewData });
    } catch (e) {
      console.log(e);
    }
  }

  validateEmail = (email) => {
    const regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(email);
  };

  handleInputChange = (e, index) => {
    const { match: { params: { id } }, match } = this.props;
    if (id) {
      const { name, value } = e.target;
      const list = [...this.state.editUserOptions];
      list[index][name] = value;
      this.setState({ editUserOptions: list });
    } else {
      const { name, value } = e.target;
      const list = [...this.state.userOptions];
      list[index][name] = value;
      this.setState({ userOptions: list });
    }
  };

  handleSubmitEdit = (e) => {
    e.preventDefault();
    const { currentRow, emails } = this.state;
    this.setState({ editUSerModal: false, currentRow: [] })
    // this.toggleEditModal(confirmationMessage);
  };

  handleInputTouch = (e, index) => {
    try {
      const { match: { params: { id } } } = this.props;
      const { name, value } = e.target;
      let { editUserOptions, userOptions } = this.state;
      let options = id ? editUserOptions : userOptions;
      if (id) {
        let { error } = handleFieldError(options[index][name], userFormFields[name]);
        options[index].errors[name] = error;
        options[index].touched[name] = true;
        this.setState({ editUserOptions: options });
      } else {
        let { error } = handleFieldError(options[index][name], userFormFields[name]);
        options[index].errors[name] = error;
        options[index].touched[name] = true;
        this.setState({ userOptions: options });
      }
    } catch (e) {
      console.log(e);
    }
  };

  handleEmailInputValidationOnTouch = async (e, index) => {
    try {
      const { match: { params: { id } }, match } = this.props;
      let { editUserOptions, userOptions } = this.state;
      let listOptions = id ? editUserOptions : userOptions;
      const { name, value } = e.target;
      const { getUserListByEmailAction, tenantId, authToken, userId } = this.props;
      let { error } = handleFieldError(listOptions[index][name], userFormFields[name]);
      listOptions[index].errors[name] = error;
      listOptions[index].touched[name] = true;
      if (name == userFormFields.email.key && value && this.validateEmail(value)) {
        const params = { list: "search", srch: value };
        let userData = null;
        // let userId = null;
        const { responseCode: { status = "" }, responseList = [] } = await getUserListByEmailAction({ tenantId, authToken, userId, params });
        if (isApiCallSuccess(status)) {
          if (responseList.length > 0) {
            userData = responseList.find((user) => user.email.toLowerCase() == value.toLowerCase());
          }
          if (userData) {
            listOptions[index]["id"] = userData.id;
            listOptions[index]["isActive"] = userData.isActive ? userData.isActive : null;
            listOptions[index]["name"] = userData.name;
          }
          else {
            listOptions[index]["isActive"] = 1;
            if (listOptions[index].hasOwnProperty("id")) {
              delete listOptions[index]['id'];
            }
          }
        }
      }
      if (id) {
        this.setState({ editUserOptions: listOptions });
      } else {
        this.setState({ userOptions: listOptions });
      }
    } catch (e) {
      console.log(e);
    }
  };

  handleEditedUserTouch = (e) => {
    try {
      let { currentRow } = this.state;
      const { error } = handleFieldError(e.target.value, userFormFields[e.target.name]);
      currentRow['errors'][e.target.name] = error;
      currentRow['touched'][e.target.name] = true;
      this.setState({ currentRow });
    } catch (e) {
      console.log(e);
    }
  };

  validateEditedUser = () => {
    try {
      let isValidUser = true;
      let { currentRow } = this.state;
      let newEditedUser = currentRow;
      if (newEditedUser) {
        if (newEditedUser.email || newEditedUser.email == null || newEditedUser.email == '') {
          const { error, isValid } = handleFieldError(newEditedUser.email, userFormFields[userFormFields.email.key]);
          newEditedUser['errors'][userFormFields.email.key] = error;
          newEditedUser['touched'][userFormFields.email.key] = true;
          isValidUser = isValid;
        }
        if (newEditedUser.name == '') {
          newEditedUser['errors'][userFormFields.name.key] = { required: true };
          newEditedUser['touched'][userFormFields.name.key] = true;
          isValidUser = false;
        }
        if (newEditedUser.roleTenantList == '') {
          newEditedUser['errors'][userFormFields.roleTenantList.key] = { required: true };
          newEditedUser['touched'][userFormFields.roleTenantList.key] = true;
          isValidUser = false;
        }
      }
      this.setState({ currentRow: newEditedUser });
      return isValidUser;
    } catch (e) {
      console.log(e);
    }
  };

  updateEditedUser = async () => {
    try {
      if (this.validateEditedUser()) {
        let { currentRow, viewData } = this.state;
        const params = {
          list: "search",
          srch: currentRow.email
        };
        let isError = false;
        let userData = null;
        let updatedUserId = null;
        const { getUserListByEmailAction, tenantId, authToken, rolesList, userId } = this.props;
        const { responseCode: { status = "" }, responseList = [] } = await getUserListByEmailAction({ tenantId, authToken, userId, params });
        if (isApiCallSuccess(status)) {
          if (responseList.length > 0) {
            userData = responseList.find((user) => user.email == currentRow.email);
            if (userData) {
              if (currentRow.email == userData.email && userData.id != currentRow.id) {
                isError = true;
                this.toast('Fail', 'Email already exists', '');
              }
            }
          }
          if (!isError) {
            if (userData) {
              updatedUserId = userData.id;
            } else {
              updatedUserId = currentRow.id;
            }
            let filteredRole = rolesList.find(role => role.roleId == currentRow.roleTenantList);
            const updatedUsers = viewData.map(user => {
              if (user.id == currentRow.id) {
                return {
                  ...user,
                  id: updatedUserId,
                  name: currentRow.name,
                  email: currentRow.email,
                  contact: currentRow.contact,
                  roleTenantList: [{ roleId: currentRow.roleTenantList, isRecActive: +currentRow.isRoleActive, isActive: 1, roleName: filteredRole.roleName }],
                  isActive: 1,
                  isRoleActive: +currentRow.isRoleActive
                };
              }
              return user;
            });
            this.setState({ editUSerModal: false, viewData: updatedUsers });
          }
        }
      }
    }
    catch (err) {
      console.log(err)
    }
  }

  handlePlatformCheck = (e, key) => {
    try {
      const { checked } = e.target;
      let { thirdPartyPlatforms } = this.state;
      thirdPartyPlatforms = thirdPartyPlatforms.map(platform => {
        if (platform.key == key) {
          platform.platformAllowed = checked;
        }
        return platform;
      });
      this.setState({ thirdPartyPlatforms });
    } catch (e) {
      console.log(e);
    }
  };

  handleAllowAllPlatformChecked = (e) => {
    try {
      const { checked } = e.target;
      let { thirdPartyPlatforms } = this.state;
      thirdPartyPlatforms = thirdPartyPlatforms.map(platform => {
        platform.platformAllowed = checked;
        return platform;
      });
      this.setState({ thirdPartyPlatforms });
    } catch (e) {
      console.log(e);
    }
  };

  areAllInfomoSeatsChecked = () => {
    try {
      let { thirdPartyPlatforms } = this.state;
      let allInfomoSeats = [];
      thirdPartyPlatforms.forEach(platform => {
        allInfomoSeats = [...allInfomoSeats, ...platform.infomoSeats];
      });
      let areAllChecked = allInfomoSeats && allInfomoSeats.every(seat => seat.checked);
      return areAllChecked;
    } catch (e) {
      console.log(e);
    }
  }

  handleAllowAllInfomoSeatsCheck = (e) => {
    try {
      const { checked } = e.target;
      let { thirdPartyPlatforms } = this.state;
      thirdPartyPlatforms = thirdPartyPlatforms.map(platform => {
        if (platform.infomoSeats) {
          platform.infomoSeats = platform.infomoSeats.map(seat => {
            if (!seat.isDisabled) {
              seat.checked = checked;
            }
            return seat;
          });
        }
        return platform;
      });
      this.setState({ thirdPartyPlatforms });
    } catch (e) {
      console.log(e);
    }
  };

  handleInfomoSeatCheck = (e, platform, infomoSeat) => {
    try {
      const { checked } = e.target;
      const { key } = platform;
      const { id } = infomoSeat;
      let { thirdPartyPlatforms } = this.state;
      thirdPartyPlatforms = thirdPartyPlatforms.map(platform => {
        if (platform.key == key) {
          platform.infomoSeats = platform.infomoSeats.map(seat => {
            if (seat.id == id) {
              seat.checked = checked;
            }
            return seat;
          });
        }
        return platform;
      });
      this.setState({ thirdPartyPlatforms });
    } catch (e) {
      console.log(e);
    }
  };

  handleSelectAllAndNone = (type) => {
    try {
      let { thirdPartyPlatforms } = this.state;
      thirdPartyPlatforms = thirdPartyPlatforms.map(platform => {
        if (platform.infomoSeats) {
          platform.infomoSeats = platform.infomoSeats.map(seat => {
            if (!seat.isDisabled) {
              seat.checked = type == 'All' ? true : false;
            }
            return seat;
          });
        }
        platform.platformAllowed = type == 'All' ? true : false;
        return platform;
      });
      this.setState({ thirdPartyPlatforms });
    } catch (e) {
      console.log(e);
    }
  };

  validateMargin = (inputValue) => {
    try {
      if (isNaN(inputValue)) {
        return { isValid: false, message: 'Not a valid number' };
      }

      const floatValue = parseFloat(inputValue);
      if (floatValue < 0 || floatValue > 99.99) {
        return { isValid: false, message: 'Margin should be greater than 0 and less than 99.99' };
      }
      const decimalPlaces = (inputValue.split('.')[1] || '').length;
      if (decimalPlaces > 2) {
        return { isValid: false, message: 'Margin should contain value with only 2 decimal places' };
      }
      return { isValid: true, message: '' };
    } catch (e) {
      console.log(e);
    }
  };

  handleInfomoSeatMarginChange = (e, platform, infomoSeat, type) => {
    try {
      const { value } = e.target;
      const { key } = platform;
      const { id } = infomoSeat;
      let { thirdPartyPlatforms } = this.state;
      const { isValid, message } = this.validateMargin(value);
      thirdPartyPlatforms = thirdPartyPlatforms.map(platform => {
        if (platform.key == key) {
          platform.infomoSeats = platform.infomoSeats.map(seat => {
            if (seat.id == id) {
              seat[type] = parseFloat(value);
              seat['error'][type] = !isValid;
              seat['error'][`${type}error`] = message;
            }
            return seat;
          });
        }
        return platform;
      });
      this.setState({ thirdPartyPlatforms });
    } catch (e) {
      console.log(e);
    }
  };

  infomoSeatMarginValid = () => {
    try {
      let valid = true;
      let { thirdPartyPlatforms } = this.state;
      let allInfomoSeats = [];
      thirdPartyPlatforms.forEach(platform => {
        allInfomoSeats = [...allInfomoSeats, ...platform.infomoSeats];
      });
      let infomoSeatsError = allInfomoSeats.map(item => {
        if (item.error && Object.keys(item.error).length > 0) {
          return item.error.hasOwnProperty('fees') ? item.error['fees'] : false;
        } else {
          return false;
        }
      });
      valid = infomoSeatsError.every(val => val === false);
      return valid;
    } catch (e) {
      console.log(e);
    }
  }

  agencyMarginValid = () => {
    try {
      let valid = true;
      let { thirdPartyPlatforms } = this.state;
      let allInfomoSeats = [];
      thirdPartyPlatforms.forEach(platform => {
        allInfomoSeats = [...allInfomoSeats, ...platform.infomoSeats];
      });
      let agencySeatsError = allInfomoSeats.map(item => {
        if (item.error && Object.keys(item.error).length > 0) {
          return item.error.hasOwnProperty('agencyFees') ? item.error['agencyFees'] : false;
        } else {
          return false;
        }
      });
      valid = agencySeatsError.every(val => val === false);
      return valid;
    } catch (e) {
      console.log(e);
    }
  }

  render() {
    const {
      acceptThumbnail,
      confirmationOpen,
      confirmationInfo,
      submited,
      errors,
      touched,
      form,
      editMode,
      isPrimaryTenant,
      activeTab,
      contact,
      tenantTypeList,
      enableToast,
      toastMsg,
      toastStatus,
      confirmationMsg,
      userOptions,
      editUserOptions,
      CurrencyListOptions,
      timeZoneOptions,
      viewData,
      editUSerModal,
      currentRow,
      updatedData,
      allCountryOptions,
      reamainBalance,
      formFields,
      phonenumberLenghtValidationPacket,
      connectionManagement,
      feeManagement,
      thirdPartyPlatforms,
      paymentTypes,
      infomoSeatsAvailable,
      payloadTenantTypeId
    } = this.state;

    const {
      configurationList,
      rolesList,
      countryList,
      getStateList,
      getCityList,
      getPincodeList,
      tenantListAll,
      tenantType,
      match: { params: { id } },
    } = this.props;

    // Find advertiser role
    const advertiser = tenantTypeList.find(item => item.value.toLowerCase() == 'advertiser');
    const roleTenantId = payloadTenantTypeId == '' && advertiser ? advertiser.key : payloadTenantTypeId;

    // Set user array based on edit mode
    const addUserArray = id ? editUserOptions : userOptions;

    // Get public roles based on tenant type
    let myPublicRoles = [];

    if (tenantType == "Platform Manager") {
      myPublicRoles = rolesList.map(({ roleId, roleName, roleType }) => ({
        id: roleId,
        value: roleName,
        roleType
      }));
    } else {
      myPublicRoles = rolesList
        .filter(role => role.roleType != 1 && role.tenantType == roleTenantId)
        .map(({ roleId, roleName, roleType }) => ({
          id: roleId,
          value: roleName,
          roleType
        }));
    }


    // Filter add user role options
    const addUserRolesOptions = myPublicRoles.filter(role => role.roleType != 3);

    // Check if edit user modal should be disabled
    let isEditUserModalDisabled = false;

    if (editUSerModal) {
      const hasRestrictedRole = myPublicRoles.some(
        role => role.id == currentRow.roleTenantList && role.roleType == 3
      );

      if (hasRestrictedRole) {
        isEditUserModalDisabled = true;
      } else {
        myPublicRoles = rolesList
          .filter(role => role.roleType == 2 && role.tenantType == roleTenantId)
          .map(({ roleId, roleName, roleType }) => ({
            id: roleId,
            value: roleName,
            roleType
          }));
      }
    }

    return (
      <>
        {confirmationOpen && (<ModalConfirmation
          open={confirmationOpen}
          onClose={this.toggleModal}
          confirmationInfo={confirmationInfo}
          handelConfirmationMessage={this.confirmationCallBack}
        />)}
        {
          enableToast && <ToastModal
            enableToast={enableToast}
            status={toastStatus}
            msg={toastMsg}
            path={routes.containers.admin + "/" + routes.admin.tenant.name}
            idProps={this.props}
            handleConfirmation={this.confirmationCallbackModel}
            handleToastStatus={this.handleToastStatus}
            confirmationMsg={confirmationMsg}
          />
        }

        <Modal open={editUSerModal} size='medium' onClose={() => { this.setState({ editUSerModal: false, currentRow: {} }) }}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit User</h5>
              <button type="button" onClick={() => { this.setState({ editUSerModal: false }) }} className="close" data-dismiss="modal" aria-label="Close">
                <div className="modal-title modal-colse modal-cross" ><span aria-hidden="true">×</span></div>
              </button>
            </div>
            <div className="modal-body form__style">
              <div className='row px-4 py-2'>
                <div className="col-md-6">
                  <Input
                    onChange={(e) => this.setState({ currentRow: { ...this.state.currentRow, [userFormFields.email.key]: e.target.value } })}
                    onBlur={(e) => this.handleEditedUserTouch(e)}
                    value={currentRow.email}
                    setting={userFormFields[userFormFields.email.key]}
                    error={currentRow['errors'][userFormFields.email.key]}
                    submited={submited}
                    touched={currentRow['touched'][userFormFields.email.key]}
                  />
                </div>

                <div className="col-md-6">
                  <Input
                    onChange={(e) => this.setState({ currentRow: { ...this.state.currentRow, [userFormFields.name.key]: e.target.value } })}
                    onBlur={(e) => this.handleEditedUserTouch(e)}
                    value={currentRow.name}
                    setting={userFormFields[userFormFields.name.key]}
                    error={currentRow['errors'][userFormFields.name.key]}
                    submited={submited}
                    touched={currentRow['touched'][userFormFields.name.key]}
                  />
                </div>

                <div className="col-md-6">
                  <Input
                    onChange={(e) => this.setState({ currentRow: { ...this.state.currentRow, [userFormFields.contact.key]: e.target.value } })}
                    onBlur={(e) => this.handleEditedUserTouch(e)}
                    value={currentRow.contact}
                    setting={userFormFields[userFormFields.contact.key]}
                    error={currentRow['errors'][userFormFields.contact.key]}
                    submited={submited}
                    touched={currentRow['touched'][userFormFields.contact.key]}
                  />
                </div>

                <div className="col-md-6">
                  <SelectNew
                    onChange={(e) => {
                      let { currentRow } = this.state;
                      currentRow[userFormFields.roleTenantList.key] = e.target.value;
                      this.setState({ currentRow });
                    }}
                    onBlur={(e) => this.handleEditedUserTouch(e)}
                    value={currentRow[userFormFields.roleTenantList.key]}
                    setting={userFormFields[userFormFields.roleTenantList.key]}
                    error={currentRow['errors'][userFormFields.roleTenantList.key]}
                    submited={submited}
                    touched={currentRow['touched'][userFormFields.roleTenantList.key]}
                    options={myPublicRoles}
                    disabled={isEditUserModalDisabled}
                  />
                </div>

                <div className="col-md-6 ">
                  <SelectNew
                    onChange={(e) => {
                      let { currentRow } = this.state;
                      currentRow['isRoleActive'] = e.target.value;
                      this.setState({ currentRow });
                    }}
                    onBlur={(e) => this.handleEditedUserTouch(e)}
                    value={currentRow['isRoleActive']}
                    setting={userFormFields[userFormFields.userStatus.key]}
                    error={currentRow['errors'][userFormFields.userStatus.key]}
                    submited={submited}
                    touched={currentRow['errors'][userFormFields.userStatus.key]}
                    options={userFormFields.userStatus.options}
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" onClick={() => this.updateEditedUser()} className="btn btn-primary" data-dismiss="modal">Save</button>
              <button type="button" onClick={() => { this.setState({ editUSerModal: false }) }} className="btn btn-secondary" data-dismiss="modal">Close</button>
            </div>
          </div>
        </Modal>

        <div className="main-panel ion form__style">
          <div className="content-wrapper">
            <BreadCrumb />
            <div className="row justify-content-center mt-3">
              <div className="col-md-12 grid-margin">

                {/* <Card>
                  <div className="float-right">
                  <Link
                      to={`/${routes.mainRoute}/${routes.containers.admin}/${routes.admin.tenant.name}`}
                    >
                      <button
                        type="button"
                        className="btn btn-primary">
                        <i className="ti ti-arrow-left"></i>Back to Tenant
                      </button>
                    </Link>
                  </div>
                </Card> */}


                <Card>
                  <div className="d-flex">
                    <div className="tabs-adj flex-grow-1">
                      {/* <ul className="nav nav-tabs nav-pills pb-3" id="myTab" role="tablist">
                        <li className="nav-item">
                          <a className={activeTab === Tabs.Tenant ? "nav-link active" : "nav-link"} onClick={this.handleNavigation} name={Tabs.Tenant} href="javascript:void(0);" role="tab">Tenant Details</a>
                        </li>
                        <li className="nav-item">
                          {<a className={activeTab === Tabs.contact ? "nav-link active" : "nav-link"} onClick={this.handleNavigation} name={Tabs.contact} href="javascript:void(0);" role="tab">Contact Details </a>
                          }
                        </li>
                       
                      </ul> */}
                      <ul class="nav nav-tabs customNav" role="tablist">
                        <li class="nav-item">
                          <button
                            type="button"
                            className={`${activeTab === Tabs.Tenant ? "nav-link active" : "nav-link"} customNavButton`}
                            onClick={this.handleNavigation} name={Tabs.Tenant} href="javascript:void(0);" role="tab"
                          >
                            Tenant Details
                          </button>
                        </li>
                        <li class="nav-item">
                          <button
                            type="button"
                            className={`${activeTab === Tabs.contact ? "nav-link active" : "nav-link"} customNavButton`}
                            onClick={this.handleNavigation} name={Tabs.contact} href="javascript:void(0);" role="tab"
                          >
                            Contact Details
                          </button>
                        </li>

                        <li class="nav-item">
                          <button
                            type="button"
                            className={`${activeTab === Tabs.user ? "nav-link active" : "nav-link"} customNavButton`}
                            onClick={this.handleNavigation} name={Tabs.user} href="javascript:void(0);" role="tab"
                          >
                            User
                          </button>
                        </li>
                      </ul>
                    </div>
                    <Link
                      to={`/${routes.mainRoute}/${routes.containers.admin}/${routes.admin.tenant.name}`}
                    >
                      <button
                        type="button"
                        className="btn btn-primary">
                        <i className="ti ti-arrow-left"></i>Back to Tenant
                      </button>
                    </Link>
                  </div>
                  {activeTab === Tabs.Tenant && <>
                    <div className='row mt-3'>
                      <div className='col-md-6'>
                        <Input
                          onChange={this.handleChange}
                          onBlur={this.handleTouch}
                          value={form[formFieldsTenant.tenantName.key]}
                          setting={formFieldsTenant[formFieldsTenant.tenantName.key]}
                          error={errors[formFieldsTenant.tenantName.key]}
                          submited={submited}
                          touched={touched[formFieldsTenant.tenantName.key]}
                          disabled={id ? true : false}
                        />
                      </div>


                      {/* <div className='col-md-6'>
                        <Select
                          onChange={this.handleChange}
                          onBlur={this.handleTouch}
                          value={form[formFieldsTenant.tenantTypeId.key]}
                          setting={formFieldsTenant[formFieldsTenant.tenantTypeId.key]}
                          error={errors[formFieldsTenant.tenantTypeId.key]}
                          submited={submited}
                          touched={touched[formFieldsTenant.tenantTypeId.key]}
                          options={formFieldsTenant.tenantTypeId.options}
                          disabled={id ? true : false}
                        />
                      </div> */}

                      <div className='col-md-6'>
                        <SelectNew
                          onChange={this.handleChange}
                          onBlur={this.handleTouch}
                          value={form[formFieldsTenant.tenantTypeId.key]}
                          setting={formFieldsTenant[formFieldsTenant.tenantTypeId.key]}
                          error={errors[formFieldsTenant.tenantTypeId.key]}
                          submited={submited}
                          touched={touched[formFieldsTenant.tenantTypeId.key]}
                          options={formFieldsTenant.tenantTypeId.options}
                          disabled={id ? true : false}
                        />
                      </div>

                      <div className='col-md-6'>
                        <Input
                          onChange={this.handleChange}
                          onBlur={this.handleTouch}
                          value={form[formFieldsTenant.accountOwnerName.key] ? form[formFieldsTenant.accountOwnerName.key] : ''}
                          setting={formFieldsTenant[formFieldsTenant.accountOwnerName.key]}
                          error={errors[formFieldsTenant.accountOwnerName.key]}
                          submited={submited}
                          touched={touched[formFieldsTenant.accountOwnerName.key]}
                        />
                      </div>

                      <div className='col-md-6'>
                        <Input
                          onChange={this.handleChange}
                          onBlur={this.handleTouch}
                          value={form[formFieldsTenant.accountOwnerEmail.key] ? form[formFieldsTenant.accountOwnerEmail.key] : ''}
                          setting={formFieldsTenant[formFieldsTenant.accountOwnerEmail.key]}
                          error={errors[formFieldsTenant.accountOwnerEmail.key]}
                          submited={submited}
                          touched={touched[formFieldsTenant.accountOwnerEmail.key]}
                        />
                      </div>

                      <div className='col-md-6'>
                        <SelectNew
                          onChange={this.handleChange}
                          onBlur={this.handleTouch}
                          value={form[formFieldsTenant.country.key]}
                          setting={formFieldsTenant[formFieldsTenant.country.key]}
                          error={errors[formFieldsTenant.country.key]}
                          submited={submited}
                          touched={touched[formFieldsTenant.country.key]}
                          options={sortArray(allCountryOptions, "value")}
                          disabled={id ? true : false}
                        />
                      </div>

                      <div className='col-md-6'>
                        <SelectNew
                          onChange={this.handleChange}
                          onBlur={this.handleTouch}
                          value={form[formFieldsTenant.currency.key]}
                          setting={formFieldsTenant[formFieldsTenant.currency.key]}
                          error={errors[formFieldsTenant.currency.key]}
                          submited={submited}
                          touched={touched[formFieldsTenant.currency.key]}
                          options={CurrencyListOptions}
                          disabled={id ? true : false}
                        />
                      </div>
                      <div className='col-md-12'>
                        <SelectNew
                          onChange={this.handleChange}
                          onBlur={this.handleTouch}
                          value={form[formFieldsTenant.timezone.key]}
                          setting={formFieldsTenant[formFieldsTenant.timezone.key]}
                          error={errors[formFieldsTenant.timezone.key]}
                          submited={submited}
                          touched={touched[formFieldsTenant.timezone.key]}
                          options={timeZoneOptions}
                          disabled={(id && form[formFieldsTenant.timezone.key]) ? true : false}
                        />
                      </div>

                      {/* <div className="col-md-6">
                        {
                          form[formFieldsTenant.country.key] ?
                            <div className='custom-test-select new'>
                              <label for="cars">Country <span className='text-danger'>*</span></label>
                              <select className={id ? "isDiabled" : ''} name="country" disabled={id ? true : false} onChange={this.handleChange}>
                                <option value="Select" disabled>Select</option>
                                {
                                  allCountryOptions.map(option => option.value === form[formFieldsTenant.country.key] ?
                                    <option value={option.value} selected>{option.value}</option> : <option value={option.value}>{option.value}</option>
                                  )
                                }
                              </select>
                            </div>
                            : <div className='custom-test-select'>
                              <label for="cars">Country <span className='text-danger'>*</span></label>
                              <select name="country" onChange={this.handleChange} className={errors[formFieldsTenant.country.key] && errors[formFieldsTenant.country.key].required ? "has-error" : ""}>
                                <option value="Select">Select</option>
                                {
                                  allCountryOptions.map(option =>
                                    <option value={option.value}>{option.value}</option>
                                  )
                                }
                              </select>
                              <span className='error-message'>{errors[formFieldsTenant.country.key] && errors[formFieldsTenant.country.key].required ? "This Field is required" : ""}</span>
                            </div>
                        }
                      </div> */}

                      {/* <div className="col-md-6 ">
                        {
                          form[formFieldsTenant.currency.key] ?
                            <div className='custom-test-select new'>
                              <label for="currency">Currency <span className='text-danger'>*</span></label>
                              <select className={id ? "isDiabled" : ''} name="currency" disabled={id ? true : false} onChange={this.handleChange} value={form[formFieldsTenant.currency.key]}>
                                <option value="" disabled >Select</option>
                                {
                                  CurrencyListOptions && CurrencyListOptions.map(option => option.value == form[formFieldsTenant.currency.key] ?
                                    <option value={option.value} selected>{option.value}</option> : <option value={option.value}>{option.value}</option>

                                  )
                                }
                              </select>
                            </div>
                            : <div className='custom-test-select'>
                              <label for="currency">Currency <span className='text-danger'>*</span></label>
                              <select name="currency" onChange={this.handleChange} value={form[formFieldsTenant.currency.key]} className={errors[formFieldsTenant.currency.key] && errors[formFieldsTenant.currency.key].required ? "has-error" : ""}>
                                <option value="">Select</option>
                                {
                                  CurrencyListOptions && CurrencyListOptions != undefined && CurrencyListOptions.map(option =>
                                    <option value={option.value}>{option.value}</option>
                                  )
                                }
                              </select>
                              <span className='error-message'>{errors[formFieldsTenant.currency.key] && errors[formFieldsTenant.currency.key].required ? "This Field is required" : ""}</span>
                            </div>
                        }
                      </div> */}

                      <div className='col-md-6 mt-2'>
                        <SelectNew
                          onChange={this.handleChange}
                          onBlur={this.handleTouch}
                          value={form[formFieldsTenant.paymentTypeId.key]}
                          setting={formFieldsTenant[formFieldsTenant.paymentTypeId.key]}
                          error={errors[formFieldsTenant.paymentTypeId.key]}
                          submited={submited}
                          touched={touched[formFieldsTenant.paymentTypeId.key]}
                          options={paymentTypes}
                        />
                      </div>

                      <div className='col-md-6 mt-2'>
                        <Input
                          onChange={this.handleChange}
                          onBlur={this.handleTouch}
                          value={form[formFieldsTenant.credit.key]}
                          setting={formFieldsTenant[formFieldsTenant.credit.key]}
                          error={errors[formFieldsTenant.credit.key]}
                          submited={submited}
                          touched={touched[formFieldsTenant.credit.key]}
                          disabled={this.checkIfCreditIsDisabled()}
                        />
                        <span className='text-primary' style={{ position: 'relative', bottom: '15px', fontSize: '12px' }}>Current Credit Balance : {reamainBalance && reamainBalance ? reamainBalance : 0}</span>
                      </div>

                      <div className='col-md-12 d-flex'>
                        <div className="col-md-6 pl-0">
                          <div className="col-md-6 mt-2">
                            <div className='form-group row mb-1'>
                              <div className="d-flex px-0">
                                <label for="connectionManagement" class="col-form-label px-0" style={{ width: 'fit-content' }}>Connection Management: </label>
                                <div className='d-flex align-items-center ml-2'>
                                  <input type="checkbox" id='connectionManagement' checked={connectionManagement} onChange={() => {
                                    this.setState({ connectionManagement: !connectionManagement, feeManagement: !connectionManagement ? connectionManagement : feeManagement });
                                  }} name='connectionManagement' />
                                  <span onClick={() => this.setState({ connectionManagement: !connectionManagement })} className="pl-2" style={{ fontSize: 14, cursor: 'pointer' }}>Allowed</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          {
                            connectionManagement &&
                            (form[formFieldsTenant.tenantTypeId.key] == 'DSP/Ad network' || form[formFieldsTenant.tenantTypeId.key] == 'Demo Agency') &&
                            <div className="col-md-6">
                              <div className='form-group row'>
                                <div className="d-flex px-0">
                                  <label for="feeManagement" class="col-form-label px-0" style={{ width: 'fit-content' }}>Fee Management: </label>
                                  <div className='d-flex align-items-center ml-2'>
                                    <input type="checkbox" id='feeManagement' checked={feeManagement} onChange={() => {
                                      if (!feeManagement) {
                                        let message = "Would you like to enable fee management for this tenant?"
                                        const info = { action: { confirmationMessage: message, type: 'feeSetting' } };
                                        this.toggleModal(info);
                                      } else {
                                        this.setState({ feeManagement: !feeManagement });
                                      }
                                    }} name='feeManagement' />
                                    <span onClick={() => this.setState({ feeManagement: !feeManagement })} className="pl-2" style={{ fontSize: 14, cursor: 'pointer' }}>Allowed</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          }
                        </div>

                        <div className='col-md-6'>
                          <BinarySelect
                            onChange={this.handleChange}
                            onBlur={this.handleTouch}
                            value={form[formFieldsTenant.isActive.key]}
                            setting={formFieldsTenant[formFieldsTenant.isActive.key]}
                            error={errors[formFieldsTenant.isActive.key]}
                            submited={submited}
                            touched={touched[formFieldsTenant.isActive.key]}
                            options={statusOptions}
                          />
                        </div>
                      </div>

                      {
                        (
                          connectionManagement ||
                          infomoSeatsAvailable) &&
                        (form[formFieldsTenant.currency.key] && form[formFieldsTenant.country.key])
                        && thirdPartyPlatforms && thirdPartyPlatforms.length > 0
                        &&
                        <div className='col-md-12 my-2'>
                          <div className='form-group row mb-1 pl-2'>
                            <div className="d-flex flex-column px-0">
                              <label for="allowedPlatforms" class="col-form-label" style={{ width: 'fit-content' }}>3rd Party Platforms Allowed:</label>
                              <div className='col-md-12 p-0'>
                                <div className='campaign-adj'>
                                  <div className="table-responsive">
                                    <div className='d-flex align-items-end mt-2 border border-bottom-0 p-1'>
                                      <a onClick={() => this.handleSelectAllAndNone('All')} href="javascript:void(0);" className='text-primary m-0 px-2'>All</a>
                                      <a onClick={() => this.handleSelectAllAndNone('None')} href="javascript:void(0);" className='text-primary m-0 px-2'>None</a>
                                    </div>
                                    <table style={{
                                      border: '1px solid #dee2e6',
                                      borderCollapse: 'collapse',
                                      width: '100%',
                                      fontFamily: 'Poppins, sans-serif'
                                    }}>
                                      <thead>
                                        <tr style={{
                                          backgroundColor: '#f8f9fa',
                                          color: '#212529',
                                        }}>
                                          <th scope="col" style={{ textAlign: 'center', padding: 10, width: '20%' }}>Platform Name</th>
                                          {
                                            infomoSeatsAvailable &&
                                            <th className='border-right border-left' scope="col" style={{ textAlign: 'center', padding: 10 }}>
                                              <div className='w-full pb-2 d-flex align-items-center justify-content-center'>
                                                <input id="allowAllInfomoSeats" className='ml-5' type="checkbox" checked={this.areAllInfomoSeatsChecked()} onChange={(e) => this.handleAllowAllInfomoSeatsCheck(e)} />
                                                <label className='m-0 pl-1' for="allowAllInfomoSeats" style={{ color: '#040B1B', fontSize: '16px' }}>Allow Infomo Seats</label>
                                              </div>
                                              {
                                                (feeManagement && form[formFieldsTenant.tenantTypeId.key] == 'DSP/Ad network') ?
                                                  <div className='d-flex w-100'>
                                                    <div style={{ width: '60%' }} className='pl-2 border-right'>
                                                      <p style={{ textAlign: 'left' }}>Seat</p>
                                                    </div>
                                                    <div style={{ width: '20%' }} className={`pl-2 ${(feeManagement && form[formFieldsTenant.tenantTypeId.key] == 'DSP/Ad network') ? 'border-right' : ''}`}>
                                                      <p style={{ textAlign: 'left' }}>Infomo Margin</p>
                                                    </div>
                                                    <div style={{ width: '20%' }} className="pl-2">
                                                      <p style={{ textAlign: 'left' }}>Agency Margin</p>
                                                    </div>
                                                  </div>
                                                  :
                                                  <div className='d-flex w-100'>
                                                    <div className='w-75 pl-2 border-right'>
                                                      <p style={{ textAlign: 'left' }}>Seat</p>
                                                    </div>
                                                    <div className="w-25 pl-2">
                                                      <p style={{ textAlign: 'left' }}>Infomo Margin</p>
                                                    </div>
                                                  </div>
                                              }
                                            </th>
                                          }
                                          {
                                            connectionManagement &&
                                            <th scope="col" style={{ textAlign: 'center', padding: 10, width: '20%' }}>
                                              <div className="d-flex align-items-center">
                                                <input className='ml-5' type="checkbox" id="allPlatformCheck" checked={thirdPartyPlatforms && thirdPartyPlatforms.every(item => item.platformAllowed == true)} onChange={(e) => this.handleAllowAllPlatformChecked(e)} />
                                                <label className='m-0 pl-1' style={{ color: '#040B1B', fontSize: '16px' }} for="allPlatformCheck">Allow Other Seats</label>
                                              </div>
                                            </th>
                                          }
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {
                                          thirdPartyPlatforms.map(platform => {
                                            return (
                                              <tr style={{
                                                backgroundColor: '#fff',
                                                color: '#212529',
                                                borderBottom: '1px solid #dfeafb'
                                              }}>
                                                <td style={{ width: '20%' }} className='text-center border-grey border-1 p-2'>{platform.value}</td>
                                                {
                                                  infomoSeatsAvailable &&
                                                  <td className='p-1'>
                                                    <table className='border-0' style={{ border: '1px solid rgb(222,  226,  230)', borderCollapse: 'collapse', width: '100%', fontFamily: 'Poppins, sans-serif' }}>
                                                      {
                                                        platform.infomoSeats.map((infomoSeat, index) => {
                                                          return (
                                                            <div key={index} className='d-flex justify-content-between'>
                                                              <tr style={{ width: (feeManagement && (form[formFieldsTenant.tenantTypeId.key] == 'DSP/Ad network' || form[formFieldsTenant.tenantTypeId.key] == 'Demo Agency')) ? '60%' : '75%' }} className='p-0'>
                                                                <td className='border-0 p-0 w-100 h-100 d-flex align-items-center justify-content-center'>
                                                                  <div className='w-100 d-flex'>
                                                                    <div style={{ width: '7%' }}>
                                                                      <input className='ml-3' type="checkbox" id={`${infomoSeat.id}`} checked={infomoSeat.checked} onChange={(e) => this.handleInfomoSeatCheck(e, platform, infomoSeat)} disabled={infomoSeat.isDisabled ? true : false} />
                                                                    </div>
                                                                    <div className='d-flex align-items-center' style={{ width: '87%' }}>
                                                                      <label className="mb-0 ml-1" for={`${infomoSeat.id}`}>{infomoSeat.displayName ? infomoSeat.displayName : infomoSeat.masterAccountName}</label>
                                                                    </div>
                                                                  </div>
                                                                </td>
                                                              </tr>

                                                              <tr style={{ width: (feeManagement && (form[formFieldsTenant.tenantTypeId.key] == 'DSP/Ad network' || form[formFieldsTenant.tenantTypeId.key] == 'Demo Agency')) ? '20%' : '25%' }} className='p-0 d-flex justify-content-left'>
                                                                <td className='border-0 p-1 d-flex flex-column justify-content-left align-items-center'>
                                                                  <div>
                                                                    <input
                                                                      style={{ border: 'none', borderBottom: `1px solid ${infomoSeat.error['fees'] ? 'red' : 'gray'}`, borderRadius: 0, width: '50%' }}
                                                                      className={`${infomoSeat.error['fees'] ? 'text-danger' : ''}`}
                                                                      type="number" min={0} max={99.99} value={infomoSeat.fees} step={0.01}
                                                                      onChange={(e) => this.handleInfomoSeatMarginChange(e, platform, infomoSeat, 'fees')}
                                                                    />
                                                                    <span>%</span>
                                                                  </div>
                                                                  {infomoSeat.error['fees'] && <span style={{ fontSize: 12 }} className='text-danger'>{infomoSeat.error['feeserror']}</span>}
                                                                </td>
                                                              </tr>

                                                              {
                                                                (feeManagement && (form[formFieldsTenant.tenantTypeId.key] == 'DSP/Ad network' || form[formFieldsTenant.tenantTypeId.key] == 'Demo Agency')) &&
                                                                <tr style={{ width: '20%' }} className='p-0 d-flex justify-content-center'>
                                                                  <td className='border-0 p-1 d-flex flex-column justify-content-left align-items-center'>
                                                                    <div>
                                                                      <input
                                                                        style={{ border: 'none', borderBottom: `1px solid ${infomoSeat.error['agencyFees'] ? 'red' : 'gray'}`, borderRadius: 0, width: '50%' }}
                                                                        className={`${infomoSeat.error['agencyFees'] ? 'text-danger' : ''}`}
                                                                        type="number" min={0} max={99.99} value={infomoSeat.agencyFees} step={0.01}
                                                                        onChange={(e) => this.handleInfomoSeatMarginChange(e, platform, infomoSeat, 'agencyFees')}
                                                                      />
                                                                      <span>%</span>
                                                                    </div>
                                                                    {infomoSeat.error['agencyFees'] && <span style={{ fontSize: 12 }} className='text-danger'>{infomoSeat.error['agencyFeeserror']}</span>}
                                                                  </td>
                                                                </tr>
                                                              }
                                                            </div>
                                                          )
                                                        })
                                                      }
                                                    </table>
                                                  </td>
                                                }
                                                {
                                                  connectionManagement &&
                                                  <td className='border-grey border-1 p-2' style={{ width: '20%' }}>
                                                    <input className='d-block mx-auto' type="checkbox" checked={platform.platformAllowed} onChange={(e) => this.handlePlatformCheck(e, platform.key)} />
                                                  </td>
                                                }
                                              </tr>
                                            )
                                          })
                                        }
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                    </div>

                  </>
                  }

                  {activeTab === Tabs.contact && <>
                    <div className='teneantFormStyle row mt-3'>

                      <div className='col-md-6'>
                        <Input
                          onChange={this.handleChange}
                          onBlur={this.handleContactTouch}
                          value={contact[formFields.organizationTitle.key]}
                          setting={formFields[formFields.organizationTitle.key]}
                          error={errors[formFields.organizationTitle.key]}
                          submited={submited}
                          touched={touched[formFields.organizationTitle.key]}
                        />
                      </div>

                      <div className='col-md-6'>
                        <Input
                          onChange={this.handleChange}
                          onBlur={this.handleContactTouch}
                          value={contact[formFields.gst.key]}
                          setting={formFields[formFields.gst.key]}
                          error={errors[formFields.gst.key]}
                          submited={submited}
                          touched={touched[formFields.gst.key]}
                        />
                      </div>

                      <div className='col-md-6'>
                        <Select
                          onChange={this.handleChange}
                          onBlur={this.handleContactTouch}
                          value={form.country ? form.country : ''}
                          setting={formFields[formFields.countrydiable.key]}
                          error={errors[formFields.countrydiable.key]}
                          submited={submited}
                          toggle={() => { alert('toggle'); }}
                          touched={touched[formFields.countrydiable.key]}
                          options={sortArray(countryList, 'countryName')}
                          disabled={true}
                        />

                        <div className='col-md-12 p-0'>
                          <Select
                            onChange={this.handleChange}
                            onBlur={this.handleContactTouch}
                            value={contact[formFields.state.key]}
                            setting={formFields[formFields.state.key]}
                            error={errors[formFields.state.key]}
                            submited={submited}
                            touched={touched[formFields.state.key]}
                            options={sortArray(form[formFieldsTenant.country.key] ? getStateList : [], 'stateName')}
                          />
                        </div>
                      </div>

                      <div className='col-md-6'>
                        <Textarea
                          onChange={this.handleChange}
                          onBlur={this.handleContactTouch}
                          value={contact[formFields.address1.key]}
                          setting={formFields[formFields.address1.key]}
                          error={errors[formFields.address1.key]}
                          submited={submited}
                          touched={touched[formFields.address1.key]}
                        />
                      </div>

                      <div className='col-md-6'>
                        <Select
                          onChange={this.handleChange}
                          onBlur={this.handleContactTouch}
                          value={contact[formFields.city.key]}
                          setting={formFields[formFields.city.key]}
                          error={errors[formFields.city.key]}
                          submited={submited}
                          touched={touched[formFields.city.key]}
                          options={sortArray(form[formFieldsTenant.country.key] && contact[formFields.state.key] ? getCityList : [], 'cityName')}
                        />

                        <div className='col-md-12 p-0'>
                          <Select
                            onChange={this.handleChange}
                            onBlur={this.handleContactTouch}
                            value={contact[formFields.pinCode.key]}
                            setting={formFields[formFields.pinCode.key]}
                            error={errors[formFields.pinCode.key]}
                            submited={submited}
                            touched={touched[formFields.pinCode.key]}
                            options={sortArray(form[formFieldsTenant.country.key] && contact[formFields.state.key] && contact[formFields.city.key] ? getPincodeList : [], 'pincode')}
                          />
                        </div>

                        <div className='col-md-12 p-0'>
                          <Input
                            onChange={this.handleChange}
                            onBlur={this.handleContactTouch}
                            value={contact[formFields.contactPerson.key]}
                            setting={formFields[formFields.contactPerson.key]}
                            error={errors[formFields.contactPerson.key]}
                            submited={submited}
                            touched={touched[formFields.contactPerson.key]}
                          />
                        </div>
                      </div>


                      <div className='col-md-6'>
                        <Textarea
                          onChange={this.handleChange}
                          onBlur={this.handleContactTouch}
                          value={contact[formFields.address2.key]}
                          setting={formFields[formFields.address2.key]}
                          error={errors[formFields.address2.key]}
                          submited={submited}
                          touched={touched[formFields.address2.key]}
                        />

                        <div className='col-md-12 p-0'>
                          <Input
                            onChange={this.handleChange}
                            onBlur={this.handleContactTouch}
                            value={contact[formFields.contactEmail.key]}
                            setting={formFields[formFields.contactEmail.key]}
                            error={errors[formFields.contactEmail.key]}
                            submited={submited}
                            touched={touched[formFields.contactEmail.key]}
                          />
                        </div>
                      </div>


                      {/* <div className="col-md-6 ">
                        <div className='custom-test-select new mt-2'>
                          <label className='mb-4' htmlFor="state">State</label>
                          <span className='small' style={{ color: 'rgba(25, 37, 35, 0.54)', position: 'relative', top: '13px', right: '36px' }} >Optional</span>

                          <select name="state" onChange={this.handleChange} value={contact[formFields.state.key]}>
                            <option value="" disabled>Select</option>
                            {getStateList && getStateList.length > 0 && getStateList.map(option => (
                              <option key={option.stateName} value={option.stateName} selected={contact[formFields.state.key] === option.stateName}>
                                {option.stateName}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div> */}


                      <div className='col-md-6'>
                        <Input
                          onChange={this.handleChange}
                          onBlur={this.handleContactTouch}
                          value={contact[formFields.contactPhone.key]}
                          setting={formFields[formFields.contactPhone.key]}
                          error={errors[formFields.contactPhone.key]}
                          submited={submited}
                          touched={touched[formFields.contactPhone.key]}
                        />
                      </div>

                    </div>
                  </>}

                  {activeTab === Tabs.user ? <>


                    {id && viewData.length > 0 && <>
                      <div className="col-12 px-0 pt-4 pb-2">
                        <h5 className="pt-2 font-weight-bold">Access allowed to Users</h5>
                      </div>
                      <div className="campaign-adj">
                        <div className="campaign-list-adj table-responsive">
                          <Table
                            options={options}
                            data={viewData || []}
                            handelAction={this.handleAction}
                          />
                        </div>
                      </div></>
                    }


                    <div className='row mt-3 mt-2'>
                      <div className='d-flex justify-content-end'>
                        <button onClick={() => this.addUser()} className="btn text-primary px-0">
                          <i style={{ fontSize: 18 }} className='ti ti-plus' />
                          <span style={{ fontSize: 14 }}>Add New User</span>
                        </button>
                      </div>


                      {
                        addUserArray.map((data, index) => {
                          return (
                            <div className="d-flex ml-2">
                              <div className="col-md-2">
                                <Input
                                  onChange={(e) => this.handleInputChange(e, index)}
                                  onBlur={(e) => this.handleEmailInputValidationOnTouch(e, index)}
                                  value={data.email}
                                  setting={userFormFields[userFormFields.email.key]}
                                  error={data['errors'][userFormFields.email.key]}
                                  submited={submited}
                                  touched={data['touched'][userFormFields.email.key]}
                                />
                              </div>

                              <div className="col-md-2 px-0">
                                <Input
                                  onChange={(e) => this.handleInputChange(e, index)}
                                  onBlur={(e) => this.handleInputTouch(e, index)}
                                  value={data.name}
                                  setting={userFormFields[userFormFields.name.key]}
                                  error={data['errors'][userFormFields.name.key]}
                                  submited={submited}
                                  touched={data['touched'][userFormFields.name.key]}
                                />
                              </div>

                              <div className="col-md-2">
                                <Input
                                  onChange={(e) => this.handleInputChange(e, index)}
                                  onBlur={(e) => this.handleInputTouch(e, index)}
                                  value={data.contact}
                                  setting={userFormFields[userFormFields.contact.key]}
                                  error={data['errors'][userFormFields.contact.key]}
                                  submited={submited}
                                  touched={data['touched'][userFormFields.contact.key]}
                                />
                              </div>

                              <div className="col-md-2">
                                <SelectNew
                                  onChange={(e) => this.handleInputChange(e, index)}
                                  onBlur={(e) => this.handleInputTouch(e, index)}
                                  value={data.roleTenantList}
                                  setting={userFormFields[userFormFields.roleTenantList.key]}
                                  error={data['errors'][userFormFields.roleTenantList.key]}
                                  submited={submited}
                                  touched={data['touched'][userFormFields.roleTenantList.key]}
                                  options={addUserRolesOptions}
                                />
                              </div>

                              <div className="col-md-2">
                                <SelectNew
                                  onChange={(e) => this.handleInputChange(e, index)}
                                  onBlur={(e) => this.handleInputTouch(e, index)}
                                  value={data.userStatus}
                                  setting={userFormFields[userFormFields.userStatus.key]}
                                  error={data['errors'][userFormFields.userStatus.key]}
                                  submited={submited}
                                  touched={data['touched'][userFormFields.userStatus.key]}
                                  options={userFormFields.userStatus.options}
                                />
                              </div>

                              {addUserArray.length > 0 &&
                                <div className='col-md-2 d-flex justify-content-start align-items-center'>
                                  <button onClick={() => this.removeUser(index)} className="btn text-primary mt-3">
                                    <i style={{ fontSize: 18 }} className='ti ti-minus' />
                                    <span style={{ fontSize: 14 }}>Remove</span>
                                  </button>
                                </div>
                              }
                            </div>
                          )
                        })
                      }
                    </div>
                  </>
                    :
                    null
                  }

                  <div className="form-group row mt-2">
                    <div className="col-sm-12">
                      <center>
                        {(activeTab === Tabs.Tenant || activeTab === Tabs.contact) ? <button type="submit" onClick={this.handleNextpage} name={activeTab === Tabs.Tenant ? Tabs.contact : Tabs.user} className="btn btn-primary">Next</button> : <button type="submit" onClick={(e) => this.handleSubmit(e)} className="btn btn-primary">Save</button>}
                        {' '}
                        {/* <button type="button" onClick={this.reset} className="btn btn-secondary">Reset</button> */}
                        {' '}
                        <Link to={`/${routes.mainRoute}/${routes.containers.admin}/${routes.admin.tenant.name}`}><button type="button" className="btn btn-secondary">Cancel</button></Link>
                      </center>
                    </div>
                  </div>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default connect(
  (state) => ({
    configurationList: get(state, 'app.configurationData.responseList', []),
    rolesList: get(state, 'app.adminRolesData.responseList', []),
    countryList: get(state, 'app.getCountryList.responseList', []),
    tenantListAll: get(state, 'app.tenantListAll.responseList', []),
    getStateList: get(state, 'app.getStateList.responseList', []),
    getCityList: get(state, 'app.getCityList.responseList', []),
    getPincodeList: get(state, 'app.getPincodeList.responseList', []),
    tenantName: get(state, 'app.preSignInState.tenantName'),
    tenantType: get(state, 'app.preSignInData.responseList[0].tenantType', ''),
    tenantId: get(state, 'app.preSignInState.tenantId', ''),
    userId: get(state, 'app.preSignInData.userId', ''),
    authToken: get(state, 'app.signInData.authToken', ''),
  }), {
  getPlatformListAction,
  getAdminRolesListAction,
  getCountryAction,
  getStateAction,
  getCityAction,
  getTenantAction,
  addTenantAction,
  editTenantAction,
  getPinCodeAction,
  getAdminUserListAction,
  postPaymentCreditAction,
  getAllCurrencyAction,
  getAllCountryAction,
  getFilterCurrencyAction,
  postWalletGetAction,
  getSubscriptionListManageServiceTrailAction,
  postRecchageSubscribeAction,
  getUserListByEmailAction,
  getAdminUserSingleListAction,
  getDataConfigDeatilsAction,
  getDataConfigDeatilsv1Action,
  getInfomoViewListAction,
  postMapDefaultSeatsAction,
  postUserMappedSeatsAction,
  configAttributeAction,
  postTenantPaymentTypeAction,
  postTenantSupportedPaymentTypesAction,
  postTenantSupportedPlatformsAction
}
)(AddTenant);

AddTenant.propTypes = {
  configurationList: PropTypes.array,
  countryList: PropTypes.array,
  tenantId: PropTypes.number,
  userId: PropTypes.number,
  authToken: PropTypes.string,
  getCountryAction: PropTypes.func,
  getTenantAction: PropTypes.func
};
